<template>
  <div :class="['detail', info.isBg === false ? 'detail-noBg' : '']" style="margin-right: 15px;" ref="screenRef"
    :style="{ '--theme-color': themeColor, '--opacity-theme': colorRgb(themeColor, 0.4) }">
    <template v-if="info.checkName">
      <div class="flex" v-if="!info.isNew">
        <span class="label">{{ info.checkName }}</span>
        <el-date-picker v-if="
          currentType === 'date' ||
          currentType === 'timeof' ||
          currentType === 'dates'
        " style="width: 100%" v-model="info.value" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="handelChange"></el-date-picker>

        <el-select size="small" v-if="info.checkName === '申请状态'" multiple collapse-tags v-model="info.value"
          placeholder="全部" @blur="handelChange">
          <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select size="small" v-if="
          [
            'status',
            'text',
            'textarea',
            'radio',
            'checkbox',
            'richTextWid',
            'new-rel-radio',
            'relation-check',
            'label',
          ].indexOf(currentType) !== -1 && info.checkName !== '申请状态'
        " multiple collapse-tags v-model="info.value" placeholder="全部" @change="handelChange">
          <el-option v-for="item in info.filterOptions || controlList" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
        <el-input size="small" v-if="currentType === 'number'" type="number" v-model="info.value"
          @change="handelChange" />
      </div>
      <template v-else>
        <!-- 新的筛选组件 -->
        <div style="display: flex;"
          :style="isLeft ? 'flex-direction: column;' : 'flex-direction: row;align-items: center;'">
          <div class="detail-tranL" :style="isLeft ? '' : 'flex: 1;'" v-if="isLeft && info.showMethods === 'tranL'">
            <template v-if="isOrganize || isRole">
              <template v-if="isDefaultFilterOpt">
                <template v-if="isOrganize">
                  <organize @change-checked="changeCheck($event, 'organization')" ref="organizeRef" />
                </template>
                <template v-else>
                  <role ref="roleRef" @change-checked="changeCheck($event, 'role')" />
                </template>
              </template>
              <template v-else>
                <template v-if="isMultipleLevel">
                  <screenTree ref="screenTreeRef" :screenInfo="info" :screenRefInfoValue="getScreenRefInfo"
                    :fontStyle="getFontStyle" :inputAppenText="inputAppenText" :getScreenList="getAppOptions"
                    :levelList="info.screenLevel.levelList" :customDeskId="customDeskId" :isInDetailed="isInDetailed"
                    @todo-inside="$emit('todo-inside', $event)" @open-dictionary="$emit('open-dictionary', $event)"
                    @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                    @open-appDialog="$emit('open-appDialog', $event)" @handleNodeClick="handleNodeClick"
                    @handleNodeCheck="handleNodeCheck" />
                </template>
                <!-- 数据值 -->
                <template v-else-if="isMultiple">
                  <el-checkbox-group @change="orgMutualCheck" v-model="orgAndRoleListValue">
                    <el-checkbox v-for="(item) in orgAndRoleList"
                      :model-value="item[isOrganize ? 'organizationId' : 'roleId']"
                      :key="item[isOrganize ? 'organizationId' : 'roleId']">
                      <span :styleInfo="getFontStyle">
                        {{ showOrgName(item) }}
                      </span>
                    </el-checkbox>
                  </el-checkbox-group>
                </template>
                <template v-else>
                  <div class="org-and-role-search-single">
                    <div v-if="info.isAppenAll"
                      :style="{ backgroundColor: isActiveRoleAndOrg('全部') ? themeColor : '', color: isActiveRoleAndOrg('全部') ? '#fff' : '' }"
                      class="org-and-role-search-single-item" @click="orgAndRoleSearchClick('全部')">全部</div>
                    <div
                      :style="{ backgroundColor: isActiveRoleAndOrg(item) ? themeColor : '', color: isActiveRoleAndOrg(item) ? '#fff' : '' }"
                      class="org-and-role-search-single-item" v-for="item in orgAndRoleList"
                      :key="isRole ? item.roleId : item.organizationId" @click="orgAndRoleSearchClick(item)">
                      <span :styleInfo="getFontStyle">
                        {{ showOrgName(item) }}
                      </span>
                    </div>
                  </div>
                </template>
              </template>
            </template>
            <template v-else>
              <!-- 左侧的筛选组件 树形 -->
              <div class="detail-tranL-name" @click="putItAwayList" v-if="info.isTitle !== 'hidden'"
                :style="{ padding: isMultiple ? '' : '0 16px' }">
                <i class="iconfont icon-wenjianjia1"></i>
                <span class="name" :style="getFontStyle">
                  {{ info.isTitle !== 'hidden' ? info.checkName : '' }}
                </span>
                <i class="iconfont icon-xiangxia" :class="isShrink ? 'xiangyou' : ''"></i>
              </div>
              <div class="detail-tranL-opt" ref="tranLopt" :style="{
                height: info.isTitle !== 'hidden' ? 'calc(100% - 40px)' : '100%',
                marginLeft: info.isTitle !== 'hidden' && isMultiple ? '28px' : isMultiple ? '6px' : '0'
              }">
                <el-scrollbar style="height: 100%;min-height: 30px;" ref="scrollbarRef">
                  <!-- 多选 -->
                  <template v-if="isMultiple">
                    <!-- 由于联系人控件 需要实时获取值 对象地址值会改变 导致饿了么的多选框无法选中 -->
                    <template v-if="isUser">
                      <div class="single-tree-head" v-if="info.isAppenSearchInput !== false">
                        <el-input placeholder="输入关键字进行过滤" size="small" v-model="optSearch" />
                        <el-icon size="24" color="#4e86ff" style="margin-left: 8px" @click="init">
                          <RefreshRight />
                        </el-icon>
                      </div>
                      <el-checkbox style="height: 40px;line-height: 40px;"
                        v-if="info.isAppenAll !== false && !isMultipleLevel" v-model="info.checkAll"
                        @change="checkChange"><span :style="getFontStyle">全部</span></el-checkbox>
                      <el-checkbox-group v-model="userList" @change="checkUserChange"
                        style="display: flex; flex-direction: column;">
                        <el-checkbox class="h-fit" v-for="(Sel, j) in optSearchList" :value="Sel.userId" :key="j">
                          <optionItem :tickList="tickList" :realValue="getRealScreenValue({ value: [Sel] }).value"
                            :customDeskId="customDeskId"
                            :moreFiledData="optionMoreData"
                            @todo-inside="$emit('todo-inside', $event)"
                            @openAppInitiate="$emit('openAppInitiate', $event)"
                            @open-dictionary="$emit('open-dictionary', $event)"
                            @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                            @open-appDialog="$emit('open-appDialog', $event)" :selInfo="Sel" v-bind="btnProps"
                            :styleInfo="getFontStyle" />
                        </el-checkbox>
                      </el-checkbox-group>
                    </template>
                    <template v-else-if="isMultipleLevel">
                      <screenTree ref="screenTreeRef" :screenInfo="info" :screenRefInfoValue="getScreenRefInfo"
                        :fontStyle="getFontStyle" :inputAppenText="inputAppenText"
                        :levelList="info.screenLevel.levelList" :getScreenList="getAppOptions"
                        :customDeskId="customDeskId" :isInDetailed="isInDetailed"
                        @todo-inside="$emit('todo-inside', $event)" @open-dictionary="$emit('open-dictionary', $event)"
                        @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                        @open-appDialog="$emit('open-appDialog', $event)" @handleNodeCheck="handleNodeCheck" />
                    </template>
                    <template v-else>
                      <div class="single-tree-head" v-if="info.isAppenSearchInput !== false">
                        <el-input placeholder="输入关键字进行过滤" size="small" v-model="optSearch" />
                        <el-icon size="24" color="#4e86ff" style="margin-left: 8px" @click="init">
                          <RefreshRight />
                        </el-icon>
                      </div>
                      <el-checkbox style="height: 40px;line-height: 40px;"
                        v-if="info.isAppenAll !== false && !isMultipleLevel" v-model="info.checkAll"
                        @change="checkChange"><span :style="getFontStyle">全部</span></el-checkbox>
                      <el-checkbox-group v-model="info.value" @change="checkChange"
                        style="display: flex; flex-direction: column;">
                        <template v-if="isObject(optSearchList[0])">
                          <el-checkbox class="h-fit" v-for="(Sel, j) in optSearchList" :value="Sel" :key="j">
                            <optionItem :tickList="tickList" :realValue="getRealScreenValue({ value: [Sel] }).value"
                              :customDeskId="customDeskId"
                              :moreFiledData="optionMoreData"
                              @todo-inside="$emit('todo-inside', $event)"
                              @openAppInitiate="$emit('openAppInitiate', $event)"
                              @open-dictionary="$emit('open-dictionary', $event)"
                              @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                              @open-appDialog="$emit('open-appDialog', $event)" :selInfo="Sel" v-bind="btnProps"
                              :styleInfo="getFontStyle" />
                          </el-checkbox>
                        </template>
                        <template v-else>
                          <el-checkbox class="h-fit" v-for="(Sel, j) in optSearchList" :value="Sel" :key="j">
                            <optionItem :tickList="tickList" :realValue="getRealScreenValue({ value: [Sel] }).value"
                              :customDeskId="customDeskId"
                              :moreFiledData="optionMoreData"
                              @todo-inside="$emit('todo-inside', $event)"
                              @openAppInitiate="$emit('openAppInitiate', $event)"
                              @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                              @open-appDialog="$emit('open-appDialog', $event)" :selInfo="Sel" v-bind="btnProps"
                              :styleInfo="getFontStyle" />
                          </el-checkbox>
                        </template>
                      </el-checkbox-group>
                    </template>
                  </template>
                  <!-- 单选 -->
                  <template v-else>
                    <template v-if="isMultipleLevel">
                      <screenTree ref="screenTreeRef" :screenInfo="info" :screenRefInfoValue="getScreenRefInfo"
                        :fontStyle="getFontStyle" :inputAppenText="inputAppenText" :getScreenList="getAppOptions"
                        :levelList="info.screenLevel.levelList" :customDeskId="customDeskId"
                        :isInDetailed="isInDetailed" @todo-inside="$emit('todo-inside', $event)"
                        @open-dictionary="$emit('open-dictionary', $event)"
                        @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                        @open-appDialog="$emit('open-appDialog', $event)" @handleNodeClick="handleNodeClick"
                        @handleNodeCheck="handleNodeCheck" />
                    </template>
                    <template v-else-if="isObject(optSearchList[0])">
                      <div class="single-tree-head" v-if="info.isAppenSearchInput !== false">
                        <el-input placeholder="输入关键字进行过滤" size="small" v-model="optSearch" />
                        <el-icon size="24" color="#4e86ff" style="margin-left: 8px" @click="init">
                          <RefreshRight />
                        </el-icon>
                      </div>
                      <div class="single-item" v-if="info.isAppenAll !== false && defalutOption.length > 0"
                        :style="[{ background: info.value[0] === '全部' ? colorRgb(themeColor, 0.1) : '' }, getFontStyle]"
                        @click="checkSingle('全部')" :class="info.value[0] === '全部' ? 'single-item-active' : ''">
                        <optionItem :tickList="tickList" :realValue="getRealScreenValue({ value: ['全部'] }).value"
                          :customDeskId="customDeskId"
                          :moreFiledData="optionMoreData"
                          @todo-inside="$emit('todo-inside', $event)"
                          @openAppInitiate="$emit('openAppInitiate', $event)"
                          @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                          @open-appDialog="$emit('open-appDialog', $event)" selInfo="全部" v-bind="btnProps"
                          :styleInfo="getFontStyle" />
                      </div>
                      <div @click="checkSingle(sel)"
                        :style="[{ background: inputAppenText[0] === sel.value ? colorRgb(themeColor, 0.1) : '' }, getFontStyle]"
                        class="single-item" :class="inputAppenText[0] === sel.value ? 'single-item-active' : ''"
                        v-for="(sel, idx) in optSearchList" :key="idx">
                        <optionItem :tickList="tickList" :realValue="getRealScreenValue({ value: [sel] }).value"
                          :customDeskId="customDeskId"
                          :moreFiledData="optionMoreData"
                          @todo-inside="$emit('todo-inside', $event)"
                          @openAppInitiate="$emit('openAppInitiate', $event)"
                          @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                          @open-appDialog="$emit('open-appDialog', $event)" :selInfo="sel" v-bind="btnProps"
                          :styleInfo="getFontStyle" />
                      </div>
                    </template>
                    <template v-else>
                      <div class="single-tree-head" v-if="info.isAppenSearchInput !== false">
                        <el-input placeholder="输入关键字进行过滤" size="small" v-model="optSearch" />
                        <el-icon size="24" color="#4e86ff" style="margin-left: 8px" @click="init">
                          <RefreshRight />
                        </el-icon>
                      </div>
                      <div class="single-item" v-if="info.isAppenAll !== false && defalutOption.length > 0"
                        :style="[{ background: info.value[0] === '全部' ? colorRgb(themeColor, 0.1) : '' }, getFontStyle]"
                        @click="checkSingle('全部')" :class="info.value[0] === '全部' ? 'single-item-active' : ''">
                        <optionItem :tickList="tickList" :realValue="getRealScreenValue({ value: ['全部'] }).value"
                          :customDeskId="customDeskId"
                          :moreFiledData="optionMoreData"
                          @todo-inside="$emit('todo-inside', $event)"
                          @openAppInitiate="$emit('openAppInitiate', $event)"
                          @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                          @open-appDialog="$emit('open-appDialog', $event)" selInfo="全部" v-bind="btnProps"
                          :styleInfo="getFontStyle" />
                      </div>
                      <div @click="checkSingle(sel)"
                        :style="[{ background: info.value[0] === sel ? colorRgb(themeColor, 0.1) : '' }, getFontStyle]"
                        class="single-item" :class="info.value[0] === sel ? 'single-item-active' : ''"
                        v-for="sel in optSearchList" :key="sel">
                        <optionItem :tickList="tickList" :realValue="getRealScreenValue({ value: [sel] }).value"
                          :customDeskId="customDeskId"
                          :moreFiledData="optionMoreData"
                          @todo-inside="$emit('todo-inside', $event)"
                          @openAppInitiate="$emit('openAppInitiate', $event)"
                          @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                          @open-appDialog="$emit('open-appDialog', $event)" :selInfo="sel" v-bind="btnProps"
                          :styleInfo="getFontStyle" />
                      </div>
                    </template>
                  </template>
                </el-scrollbar>
              </div>
            </template>
          </div>

          <div class="detail-screen flex" v-else :style="isLeft ? 'padding: 0 10px' : 'flex: 1;'">
            <span class="label" v-if="info.isTitle !== 'hidden'"
              :style="[getFontStyle, { lineHeight: isCustomCheck ? '30px' : '' }]">{{ info.checkName }}</span>
            <!-- 自定义勾选样式 -->
            <div v-if="isCustomCheck">
              <el-checkbox class="custom-checkbox" :style="getCheckBoxStyle" v-model="info.value[0]"
                @change="customCheckChange" :true-label="info.customOption[0].value"
                :false-label="info.customOption[1].value"></el-checkbox>
            </div>
            <div v-else-if="!isDefault" class="detail-screen-default" style="height: 100%">
              <template v-if="isNewRelRadio">
                <!-- 关联单选另外写 -->
                <el-select style="width: 100%;"
                  :value-key="getControlConfig.selectTable && getControlConfig.selectTable === 'customization' && getControlConfig.isSource && getControlConfig.isSource === 2 ? getControlConfig.list[0].name : getControlConfig.selectTable && getControlConfig.selectTable === 'sys' ? getControlConfig.list[0].field : ''"
                  @focus="selectFocus" @change="changeNewRelRadio" v-model="newRelRadioValue">
                  <template v-if="getControlConfig.selectTable && getControlConfig.selectTable === 'sys'">
                    <el-option v-for="(item, inx) in newRelRadioList" :key="inx"
                      :style="{ width: widthOption + 'px', maxWidth: widthOption + 'px' }"
                      :label="item[getControlConfig.list[0].field]" :value="item">
                    </el-option>
                  </template>
                  <template
                    v-else-if="getControlConfig.selectTable && getControlConfig.selectTable === 'customization' && getControlConfig.isSource && getControlConfig.isSource === 2">
                    <el-option v-for="(item, inx) in newRelRadioList" :key="inx"
                      :style="{ width: widthOption + 'px', maxWidth: widthOption + 'px' }"
                      :label="item[getControlConfig.list[0].name]" :value="item">
                    </el-option>
                  </template>
                  <template v-else>
                    <el-option v-for="item in newRelRadioList" :key="item.approvingId"
                      :style="{ width: widthOption + 'px', maxWidth: widthOption + 'px' }" :label="item.自定义标题"
                      :value="item.approvingId">
                    </el-option>
                  </template>
                </el-select>
              </template>
              <template v-else>
                <!-- 组织控件和角色控件不要显示 -->
                <template v-if="(!isOrganize && !isRole)">
                  <el-select
                    :class="[(conditionValue === 'between' || isDate) ? 'between-select' : '', isNum ? 'num-select' : '']"
                    v-if="!(isUserSel && isUser)" @change="dealCondition" :placeholder="info.placeholder || '请选择'"
                    v-model="conditionValue" class="detail-screen-default-select">
                    <el-option :key="idx" :value="item.val" :label="item.name" v-for="(item, idx) in looperOption" />
                  </el-select>
                </template>
                <el-date-picker :style="{'--el-component-size': '30px'}" v-if="isDate" v-model="info.value" type="daterange" value-format="YYYY-MM-DD"
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                  @change="dealCondition(conditionValue, false, true)"
                  class="detail-screen-default-date"></el-date-picker>
                <template v-else-if="isNum">
                  <template v-if="isBetween">
                    <el-input @change="dealCondition(conditionValue)" type="number" v-model="info.value[0]" />
                    <div style="display:inline-block;width:7%;color:#666666;text-align:center;white-space: nowrap;"
                      v-if="isBetween">----</div>
                    <el-input @change="dealCondition(conditionValue)" type="number" v-model="info.value[1]" />
                  </template>
                  <template v-else>
                    <el-input @change="dealCondition(conditionValue)" type="number" v-model="info.value[0]" />
                  </template>
                </template>
                <template v-else-if="isOrganize || isRole">
                  <el-popover :width="popWidth" :visible="isAppenPop" trigger="click" ref="popoverRef" popper-class="screen-popp"
                    :style="isLeft ? 'display: flex;align-items: center; width: 100%;' : 'flex: 1;height: 100%;'"
                    placement="bottom">
                    <template #reference>
                      <div class="detail-screen-default-orgselect" ref="orgSelectRef">
                        <el-select @click.stop="showOrgAndRoleList" class="detail-screen-default-orgselect-pop"
                          :placeholder="info.placeholder || '请选择'" multiple @remove-tag="removeTag" collapse-tags
                          :model-value="orgAndRoleAppenText" :readonly="true" style="overflow: hidden;" />
                      </div>
                    </template>
                    <div @click.stop style="height: 240px;overflow: hidden" :style="{ paddingBottom: isRole ? '40px' : '20px' }">
                      <el-input @keydown.enter="goOrgAndRoleSearch" ref="popInput" v-model="orgAndRoleSearchText"
                        placeholder="请搜索">
                        <template #prefix>
                          <i class="el-input__icon el-icon-search"></i>
                        </template>
                      </el-input>
                      <template v-if="isOrgAndRoleSearch">
                        <template v-if="isMultiple">
                          <template v-if="isOrganize">
                            <el-checkbox-group v-model="info.organizationList" @change="orgAndRoleSearchClick">
                              <el-checkbox v-for="(item) in orgAndRoleSearchList" :value="item"
                                :key="item.organizationId">
                                <span :styleInfo="getFontStyle">
                                  {{ showOrgName(item) }}
                                </span>
                              </el-checkbox>
                            </el-checkbox-group>
                          </template>
                          <template v-else>
                            <el-checkbox-group v-model="info.roleList" @change="orgAndRoleSearchClick">
                              <el-checkbox v-for="(item) in orgAndRoleSearchList" :value="item" :key="item.roleId">
                                <span :styleInfo="getFontStyle">
                                  {{ showOrgName(item) }}
                                </span>
                              </el-checkbox>
                            </el-checkbox-group>
                          </template>
                        </template>
                        <template v-else>
                          <div class="org-and-role-search-single">
                            <div
                              :style="{ backgroundColor: isActiveRoleAndOrg(item) ? themeColor : '', color: isActiveRoleAndOrg(item) ? '#fff' : '' }"
                              class="org-and-role-search-single-item" v-for="item in orgAndRoleSearchList"
                              :key="isRole ? item.roleId : item.organizationId" @click="orgAndRoleSearchClick(item)">
                              <span :styleInfo="getFontStyle">
                                {{ showOrgName(item) }}
                              </span>
                            </div>
                          </div>
                        </template>
                      </template>
                      <template v-else>
                        <template v-if="isRole">
                          <template v-if="isDefaultFilterOpt">
                            <role ref="roleRef" @change-checked="changeCheck($event, 'role')" />
                          </template>
                          <template v-else>
                            <template v-if="isMultiple">
                              <el-checkbox-group v-model="info.roleList" @change="orgAndRoleSearchClick">
                                <el-checkbox v-for="(item) in orgAndRoleList" :value="item" :key="item.roleId">
                                  <span :styleInfo="getFontStyle">
                                    {{ showOrgName(item) }}
                                  </span>
                                </el-checkbox>
                              </el-checkbox-group>
                            </template>
                            <template v-else>
                              <div class="org-and-role-search-single">
                                <div v-if="info.isAppenAll"
                                  :style="{ backgroundColor: isActiveRoleAndOrg('全部') ? themeColor : '', color: isActiveRoleAndOrg('全部') ? '#fff' : '' }"
                                  class="org-and-role-search-single-item" @click="orgAndRoleSearchClick('全部')">全部</div>
                                <div
                                  :style="{ backgroundColor: isActiveRoleAndOrg(item) ? themeColor : '', color: isActiveRoleAndOrg(item) ? '#fff' : '' }"
                                  class="org-and-role-search-single-item" v-for="item in orgAndRoleList"
                                  :key="isRole ? item.roleId : item.organizationId"
                                  @click="orgAndRoleSearchClick(item)">{{ showOrgName(item) }}</div>
                              </div>
                            </template>
                          </template>
                        </template>
                        <template v-else-if="isOrganize">
                          <template v-if="isDefaultFilterOpt">
                            <organize @change-checked="changeCheck($event, 'organization')" ref="organizeRef" />
                          </template>
                          <template v-else>
                            <template v-if="isMultiple">
                              <el-checkbox-group v-model="orgAndRoleListValue" @change="orgMutualCheck">
                                <el-checkbox v-for="(item) in orgAndRoleList" :value="item.organizationId"
                                  :key="item.organizationId">
                                  <span :style="getFontStyle">
                                    {{ showOrgName(item) }}
                                  </span>
                                </el-checkbox>
                              </el-checkbox-group>
                            </template>
                            <template v-else>
                              <div class="org-and-role-search-single">
                                <div
                                  :style="{ backgroundColor: isActiveRoleAndOrg(item) ? themeColor : '', color: isActiveRoleAndOrg(item) ? '#fff' : '' }"
                                  class="org-and-role-search-single-item" v-for="item in orgAndRoleList"
                                  :key="isRole ? item.roleId : item.organizationId"
                                  @click="orgAndRoleSearchClick(item)">{{ showOrgName(item) }}</div>
                              </div>
                            </template>
                          </template>
                        </template>
                      </template>
                    </div>
                  </el-popover>
                </template>
                <template v-if="isAppenDropDown && getControlConfig.isEnterChoice">
                  <userDropDown :data="getControlConfig" :placeholder="info.placeholder || '请输入关键词'"
                    :formdata="info.organize" @closeFlow="closeFlow" @userCheck="userCheckCallback" />
                </template>
                <template v-else-if="isUser">
                  <template v-if="!isOptSearch">
                    <div class="user-select">
                      <div class="user-select-pop" v-show="isUserSel && isUser" ref="userSelectRef"
                        style="overflow: hidden;width: 100%;height: 30px">
                        <template v-for="(user) in info.organize" :key="user.userId">
                          <el-tag type="info" closable :disable-transitions="false" @close="removeUserTag(user.userId)">
                            {{ user.realname }}
                          </el-tag>
                        </template>
                        <el-input @keyup.enter="goSelUser" @click.stop @focus.stop="goSelUser" v-model="userSelectText"
                          :placeholder="info.placeholder || '请输入关键字'"></el-input>
                        <div class="user-select-icon" title="组织查找" @click="openUserOrg">
                          <i class="iconfont icon-zuzhijigou"></i>
                        </div>
                        <div class="dividingLine"></div>
                        <div class="user-select-icon" title="批量查找" @click="openSearchUser">
                          <i class="iconfont icon-kuaisuchazhao"></i>
                        </div>
                      </div>
                      <linked-drop-down ref="linkedDropDownRef" :isDoor="true" :isAppenSelect="isMultiple"
                        :itemInfo="getControlConfig" :userPopWidth="userPopWidth" :formdata="tranLUserList"
                        @userCheck="userCheckCallback" />
                    </div>
                  </template>
                  <template v-else>
                    <div class="user-select-pop" v-show="isUserSel && isUser" ref="userSelectRef"
                      style="overflow: hidden;width: 100%;height: 30px;">
                      <el-input @keyup.enter="goOptSearchUser" v-model="userSelectText"
                        :placeholder="info.placeholder || '请输入关键字'"></el-input>
                      <div class="user-select-icon" title="组织查找" @click="openUserOrg">
                        <i class="iconfont icon-zuzhijigou"></i>
                      </div>
                      <div class="dividingLine"></div>
                      <div class="user-select-icon" title="批量查找" @click="openSearchUser">
                        <i class="iconfont icon-kuaisuchazhao"></i>
                      </div>
                    </div>
                  </template>
                </template>
              </template>
            </div>
            <template v-else>
              <template v-if="info.showMethods === 'verticalL' && info.activeName !== 'text'">
                <div style="height: 100%" class="verticalL">
                  <div style="width:calc(100% - 30px);overflow: hidden">
                    <div class="verticalL-item" ref="verticalLItem"
                      :style="{ transform: `translateX(${transformX}px)` }">
                      <template v-if="isMultiple">
                        <el-checkbox style="margin-right: 10px;" v-if="info.isAppenAll !== false && !(isMultipleLevel)"
                          v-model="info.checkAll" @change="checkChange"><span
                            :style="getFontStyle">全部</span></el-checkbox>
                        <el-checkbox-group v-model="info.value" @change="checkChange"
                          style="display: flex;align-items: center;">
                          <template v-if="isObject(optSearchList[0])">
                            <el-checkbox class="verticalL-item-checkbox" ref="singleItem"
                              v-for="(Sel, j) in optSearchList" :value="Sel" :key="j">
                              <optionItem :tickList="tickList" :realValue="getRealScreenValue({ value: [Sel] }).value"
                                :customDeskId="customDeskId"
                                :moreFiledData="optionMoreData"
                                @todo-inside="$emit('todo-inside', $event)"
                                @openAppInitiate="$emit('openAppInitiate', $event)"
                                @open-dictionary="$emit('open-dictionary', $event)"
                                @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                                @open-appDialog="$emit('open-appDialog', $event)" :selInfo="Sel" v-bind="btnProps" />
                            </el-checkbox>
                          </template>
                          <template v-else>
                            <el-checkbox class="verticalL-item-checkbox" ref="singleItem"
                              v-for="(Sel, j) in optSearchList" :value="Sel" :key="j">
                              <optionItem :tickList="tickList" :realValue="getRealScreenValue({ value: [Sel] }).value"
                                :customDeskId="customDeskId"
                                :moreFiledData="optionMoreData"
                                @todo-inside="$emit('todo-inside', $event)"
                                @openAppInitiate="$emit('openAppInitiate', $event)"
                                @open-dictionary="$emit('open-dictionary', $event)"
                                @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                                @open-appDialog="$emit('open-appDialog', $event)" :selInfo="Sel" v-bind="btnProps" />
                            </el-checkbox>
                          </template>
                        </el-checkbox-group>
                      </template>
                      <template v-else>
                        <div class="single-item" :style="getFontStyle" v-if="info.isAppenAll !== false"
                          ref="singleItemAll" @click="checkSingle('全部')"
                          :class="info.value[0] === '全部' ? 'single-item-active' : ''">全部</div>
                        <template v-if="isObject(optSearchList[0])">
                          <div @click="checkSingle(sel)" ref="singleItem" class="single-item" :style="getFontStyle"
                            :class="inputAppenText[0] === sel.value ? 'single-item-active' : ''"
                            v-for="(sel, idx) in optSearchList" :key="idx">
                            <optionItem :tickList="tickList" :realValue="getRealScreenValue({ value: [sel] }).value"
                              :customDeskId="customDeskId"
                              :moreFiledData="optionMoreData"
                              @todo-inside="$emit('todo-inside', $event)"
                              @openAppInitiate="$emit('openAppInitiate', $event)"
                              @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                              @open-appDialog="$emit('open-appDialog', $event)" :selInfo="sel" v-bind="btnProps"
                              :styleInfo="getFontStyle" />
                          </div>
                        </template>
                        <template v-else>
                          <div @click="checkSingle(sel)" ref="singleItem" class="single-item" :style="getFontStyle"
                            :class="info.value[0] === sel ? 'single-item-active' : ''" v-for="sel in optSearchList"
                            :key="sel">
                            <optionItem :tickList="tickList" :realValue="getRealScreenValue({ value: [sel] }).value"
                              :customDeskId="customDeskId"
                              :moreFiledData="optionMoreData"
                              @todo-inside="$emit('todo-inside', $event)"
                              @openAppInitiate="$emit('openAppInitiate', $event)"
                              @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                              @open-appDialog="$emit('open-appDialog', $event)" :selInfo="sel" v-bind="btnProps"
                              :styleInfo="getFontStyle" />
                          </div>
                        </template>
                      </template>
                    </div>
                  </div>
                  <div class="change-tab" v-if="isAppenTab">
                    <div class="change-tab-item" @click="changeTab('left')">
                      <i class="iconfont icon-xia" :class="isMin ? 'is-disabled' : ''"></i>
                    </div>
                    <div class="change-tab-item" @click="changeTab('right')">
                      <i class="iconfont icon-you" :class="isMax ? 'is-disabled' : ''"></i>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <template v-if="info.showMethods === 'tranL'">
                  <el-scrollbar class="tranL-content">
                    <el-select class="select-hidden-options" :placeholder="info.placeholder || '请选择'" multiple
                      @remove-tag="removeTag" collapse-tags v-if="!isTextSearch" v-model="inputAppenText"
                      :disabled="true" style="overflow: hidden;" />
                    <el-input v-model="optSearch" placeholder="请搜索">
                      <template #prefix>
                        <el-icon>
                          <Search />
                        </el-icon>
                      </template>
                    </el-input>
                    <el-checkbox v-model="info.checkAll" @change="checkChange" style="margin-bottom: 10px;"
                      v-if="info.isAppenAll !== false">全部</el-checkbox>
                    <el-checkbox-group v-model="info.value" @change="checkChange"
                      style="display: flex; flex-direction: column;">
                      <template v-if="isObject(optSearchList[0])">
                        <el-checkbox v-for="(Sel, j) in optSearchList" :value="Sel" :key="j">
                          <optionItem :tickList="tickList" :realValue="getRealScreenValue({ value: [Sel] }).value"
                            :customDeskId="customDeskId"
                            :moreFiledData="optionMoreData"
                            @todo-inside="$emit('todo-inside', $event)"
                            @openAppInitiate="$emit('openAppInitiate', $event)"
                            @open-dictionary="$emit('open-dictionary', $event)"
                            @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                            @open-appDialog="$emit('open-appDialog', $event)" :selInfo="Sel" v-bind="btnProps" />
                        </el-checkbox>
                      </template>
                      <template v-else>
                        <el-checkbox v-for="(Sel, j) in optSearchList" :value="Sel" :key="j">
                          <optionItem :tickList="tickList" :realValue="getRealScreenValue({ value: [Sel] }).value"
                            :customDeskId="customDeskId"
                            :moreFiledData="optionMoreData"
                            @todo-inside="$emit('todo-inside', $event)"
                            @openAppInitiate="$emit('openAppInitiate', $event)"
                            @open-dictionary="$emit('open-dictionary', $event)"
                            @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                            @open-appDialog="$emit('open-appDialog', $event)" :selInfo="Sel" v-bind="btnProps" />
                        </el-checkbox>
                      </template>
                    </el-checkbox-group>
                  </el-scrollbar>
                </template>
                <template v-else>
                  <el-popover :width="popWidth" :disabled="isTextSearch" ref="popoverRef" trigger="click" :visible="isAppenPop" popper-class="screen-popp"
                    :style="isLeft ? 'flex: 1;display: flex;align-items: center; width: 100%;' : 'flex: 1;height: 100%;'"
                    placement="bottom">
                    <template #reference>
                      <el-select class="select-hidden-options" :placeholder="info.placeholder || '请选择'" multiple
                        @remove-tag="removeTag" collapse-tags
                        v-if="!isTextSearch && retractShowValue.length > 0 && isMultipleLevel"
                        v-model="retractShowValue" :disabled="true" style="overflow: hidden;width: 100%;"
                        @click.stop="showList" ref="defaultShowRef" />
                      <el-select class="select-hidden-options" :placeholder="info.placeholder || '请选择'" multiple
                        @remove-tag="removeTag" collapse-tags v-else-if="!isTextSearch" v-model="inputAppenText"
                        :disabled="true" style="overflow: hidden;width: 100%;" ref="defaultShowRef"
                        @click.stop="showList" />
                    </template>
                    <el-scrollbar class="screen-popp-content" @click.stop>
                      <!-- 筛选树 -->
                      <template v-if="isMultipleLevel">
                        <screenTree ref="screenTreeRef" :getScreenList="getAppOptions" :screenInfo="info"
                          :screenRefInfoValue="getScreenRefInfo" :fontStyle="getFontStyle"
                          :levelList="info.screenLevel.levelList" :customDeskId="customDeskId"
                          :isInDetailed="isInDetailed" @handleNodeClick="handleNodeClick"
                          @handleNodeCheck="handleNodeCheck" />
                      </template>
                      <template v-else>
                        <el-input v-model="optSearch" ref="popInput" placeholder="请搜索">
                          <el-icon>
                            <Search />
                          </el-icon>
                        </el-input>
                        <el-checkbox v-model="info.checkAll" @change="checkChange" style="margin-bottom: 10px;"
                          v-if="info.isAppenAll !== false">全部</el-checkbox>
                        <el-checkbox-group v-model="info.value" @change="checkChange"
                          style="display: flex; flex-direction: column;">
                          <template v-if="isObject(optSearchList[0])">
                            <el-checkbox v-for="(Sel, j) in optSearchList" :value="Sel" :key="j">
                              <optionItem :tickList="tickList" :realValue="getRealScreenValue({ value: [Sel] }).value"
                                :customDeskId="customDeskId"
                                :moreFiledData="optionMoreData"
                                @todo-inside="$emit('todo-inside', $event)"
                                @open-dictionary="$emit('open-dictionary', $event)"
                                @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                                @open-appDialog="$emit('open-appDialog', $event)" :selInfo="Sel" v-bind="btnProps" />
                            </el-checkbox>
                          </template>
                          <template v-else>
                            <el-checkbox v-for="(Sel, j) in optSearchList" :value="Sel" :key="j">
                              <optionItem :tickList="tickList" :realValue="getRealScreenValue({ value: [Sel] }).value"
                                :customDeskId="customDeskId"
                                :moreFiledData="optionMoreData"
                                @todo-inside="$emit('todo-inside', $event)"
                                @open-dictionary="$emit('open-dictionary', $event)"
                                @custom-scene="$emit('custom-scene', $event)" @to-nav="$emit('to-nav', $event)"
                                @open-appDialog="$emit('open-appDialog', $event)" :selInfo="Sel" v-bind="btnProps" />
                            </el-checkbox>
                          </template>
                        </el-checkbox-group>
                      </template>
                    </el-scrollbar>
                  </el-popover>
                </template>
              </template>
              <el-input v-if="isTextSearch" @keydown.enter="dealDefaultDate"
                v-model="searchValue" style="width: 100%;" :placeholder="info.placeholder || '请搜索'">
                <template #prefix>
                  <el-icon><Search /></el-icon>
                </template>
              </el-input>
            </template>
          </div>
          <screenItem v-for="item in screenItemList" :masterValue="info.value" :masterInfo="info"
            :themeColor="themeColor" :options="getScreenItemOpt(item)" :key="item.title" :info="item"
            :screenType="item.type" :isLeft="isLeft" :getFontStyle="getFontStyle" v-show="item.showType !== 'hide'"
            :style="isLeft ? '' : 'flex: 1;'" @change="screenItemChange" />
        </div>
      </template>
    </template>
    <div class="screen" v-else>筛选组件</div>
    <multiple-choice ref="multipleChoiceRef" @fromMultipleChoice="fromMultipleChoice" />
    <batch-search ref="batchSearchRef" @batchSearchChild="handleBatchSearchChild" />
  </div>
</template>
<script>
export default {
  name: 'screenComp',
}
</script>

<script setup>
import { numConditionFn, dateConditionFn, control, getUserParam } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { getapprovalbindval, getapprovalfieldoptions } from '@/port/admins/instrument'
import { getopenuserlist } from '@/port/clientSide/multipleChoice'
import { colorRgb, isScrollAtBottom } from '@/components/schoolInstrument/mixins/utils'
import { axiosBase } from '@/api/api'
import { linkedSetEvent, isStandardClass, getClassInfo, getOrgShowName } from '@/api/global'
import { cloneDeep } from 'lodash'
import { openapiGetoptions } from "@/port/admins/wordbook";
import { getlinkeddatalist } from '@/port/clientSide/oaExamineAudit'
import { getnoopenusertiplist, getdepttiplist } from '@/port/admins/organizationUser'
import { getapiorganizationlist, getapiuserlist, getopenrolelist } from '@/port/clientSide/multipleChoice'


import linkedDropDown from '@/components/clientSide/formFillinPageChild/linkedDropDown.vue'
import userDropDown from '@/components/clientSide/formFillinPageChild/userDropDown.vue'
import batchSearch from '@/components/clientSide/formFillinPageChild/batchSearch'
import multipleChoice from '@/components/common/multipleChoice.vue'
import role from '@/components/common/multipleChoice/role.vue'
import organize from '@/components/common/multipleChoice/organize.vue'
import optionItem from './optionItem.vue'
import screenTree from './screenTree.vue'
import screenItem from './screenItem.vue'

import { openapiGetapproval } from '@/port/clientSide/applicationRouting'
import { apiGetreportdatalist } from '@/port/clientSide/formFillinPageChild/newRelRadio.js'
import { getData, statusMap, formatRole, formatOrg, getFileterList } from './utils/utils.js'
import { getConditionTime } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { getFilterValue } from '@/util/customData.js'
import dayjs from 'dayjs'
import jsonType from '@/assets/json/types'

import { reactive, ref, computed, watch, defineProps, nextTick, defineEmits, useAttrs, getCurrentInstance, useTemplateRef, defineExpose } from 'vue';
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { uniqBy } from 'lodash'

const route = useRoute()
const store = useStore()
const attrs = useAttrs()
const { proxy: $vm } = getCurrentInstance()

// Data
const statusList = [
  { label: '待审批', value: 0 },
  { label: '已通过', value: 1 },
  { label: '未通过', value: 2 },
  { label: '已撤回', value: 3 },
]
const conditionValue = ref('');
const searchValue = ref('');
const optSearch = ref('');
const isShrink = ref(false);
const transformX = ref(0);
const isMax = ref(false);
const isMin = ref(true);
const isAppenTab = ref(false);
const isAppenUserPop = ref(false);
const newRelRadioValue = ref('');
const widthOption = ref(0);
const isItManual = ref(false);
const skey = ref('');
const isData = ref(true);
const isAppenPop = ref(false);
const userPopWidth = ref(300);
const userSelectText = ref('');
const userCurpage = ref(1);
const isBottom = ref(false);
const orgAndRoleSearchText = ref('');
const isOrgAndRoleSearch = ref(false);
const orgAndRoleList = ref([]);
const orgAndRoleListValue = ref([]);
const optionMoreData = ref({}); // 单级数据值选项对应的其他字段数据
const optionMoreChildrenData = ref({}); // 单级数据值选项对应的其他字段数据给子筛选用的
const screenResValue = ref([]);
const screenItemInit = ref({}); // 判断子筛选是否初始化完成
const isParentExpand = ref(false);
const relationScreenInit = ref({}); // 数据源选项关联的筛选
const isUpace = ref(route.query.upaceid);
const popWidth = ref(320)


// refs
const tranLopt = ref(null);
const scrollbarRef = ref(null);
const userSelectRef = ref(null);
const linkedDropDownRef = ref(null);
const multipleChoiceRef = ref(null);
const batchSearchRef = ref(null);
const singleItemAll = ref(null);
const singleItem = ref([]);
const verticalLItem = ref(null);
const organizeRef = ref(null);
const roleRef = ref(null);
const popoverRef = useTemplateRef('popoverRef')
const popInput = useTemplateRef('popInput')
const orgSelectRef = useTemplateRef('orgSelectRef')
const defaultShowRef = useTemplateRef('defaultShowRef')
const controlList = ref([]);
const radioList = ref([]);
const inputAppenText = ref([]);
const linkUserList = ref([]);
const newRelRadioList = ref([]);
const userType = ref({});
const userList = ref([]);
const tempUserList = ref([]);
const organizationType = ref([]);
const newRelRadioCover = ref({});
const unconditionalLinkageData = ref({});
const retractShowValue = ref([]);
const roleSearchList = ref([]);
const orgSearchList = ref([]);
const tickList = ref([]);
const optionApproval = ref({});

const filterValueObj = ref({});
const lableValueObj = ref({});

const tranLUserList = reactive([]);
const statusText = reactive(['进行中', '已通过', '未通过', '已撤回']);

const spaceid = reactive(route.query.spaceid);
const upaceid = reactive(route.query.upaceid);
let info = reactive({});


// Props
const props = defineProps({
  dataInfo: {
    type: Object,
    default: () => {
      return {}
    },
  },
  screenRef: {
    type: Array,
    default: () => ([])
  },
  themeColor: {
    type: String,
    default: '#4e86ff'
  },
  isInit: {
    type: Boolean,
    default: true
  },
  // 是否在左侧的筛选组件
  isLeft: {
    type: Boolean,
    default: false
  },
  applyInfo: {
    type: Object,
    default: () => ({})
  },
  fontStyle: {
    type: Object,
    default: () => {
      return {}
    }
  },
  powerData: {
    type: Object,
    default: () => ({})
  },
  totalParams: {
    type: Object,
    default: () => ({})
  },
  pageId: {
    type: String,
    default: '7'
  },
  noChangeScreenId: {
    type: Number,
    default: -1
  },
  addConfig: {
    type: Object,
    default: () => ({ property: [], formdata: [] })
  },
  isAppDesign: {
    type: Boolean,
    default: false
  },
  customDeskId: {
    type: [Number, String],
    default: 0,
  },
  // 是否是门户明细表篇
  isInDetailed: {
    type: Boolean,
    default: false
  },
  // 是否是筛选后加载 空值不加载
  isSotpInitTable: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits([
  'change-value', 'change', 'change-new-screen',
  'change-screen-id', 'close-loading', 'todo-inside',
  'openAppInitiate', 'open-dictionary', 'custom-scene',
  'to-nav', 'open-appDialog', 'change-new-rel-radio'
])

// Computed
const levelInfo = computed(() => {
  if (!info) return {}
  const screenLevel = info.screenLevel
  if (screenLevel && screenLevel.levelList) {
    let ele = []
    if (screenLevel.levelType === 'single') {
      ele = screenLevel.levelList[0]
    } else {
      ele = screenLevel.levelList[screenLevel.levelList.length - 1]
    }
    return ele || {}
  } else {
    return {}
  }
})

const isMultipleLevel = computed(() => {
  return info.screenLevel && info.screenLevel.levelType === 'multiple'
})

// 是否是自定义选项的勾选状态
const isCustomCheck = computed(() => {
  return info && info.activeName === 'custom' && info.customOptionType === 'check'
})
// 关联的筛选组件
const relationScreen = computed(() => {
  const list = []
  if (info.screenLevel && info.screenLevel.levelType === 'single' && info.screenLevel.levelNum === 1) {
    info.screenLevel.levelList.forEach(levelItem => {
      if (levelItem.rulerData.fixquery && Array.isArray(levelItem.rulerData.fixquery.linked)) {
        levelItem.rulerData.fixquery.linked.forEach(linkItem => {
          if (linkItem.screenValue) {
            linkItem.screenValue.forEach(screenValueItem => {
              list.push(screenValueItem[0])
            })
          }
        })
      }
    })
  }
  return Array.from(new Set(list))
})

const currentType = computed(() => {
  if (info.activeName === 'dictionary' || info.activeName === 'custom') {
    return 'text'
  }
  if (info.screenLevel && info.screenLevel.levelType === 'single' && info.screenLevel.levelList.length > 0) {
    const field = info.screenLevel.levelList[0].field
    return field.split('_')[2]
  } else {
    return info.screenType
  }
})

const getCheckBoxStyle = computed(() => {
  const checkBoxStyle = {}
  if (props.dataInfo && props.dataInfo.fontStyle && props.dataInfo.fontStyle.fontSize) {
    const fontSize = props.dataInfo.fontStyle.fontSize.split('px')[0]
    checkBoxStyle.transform = `scale(${Number(fontSize) / 14})`
  }
  return checkBoxStyle
})


const screenItemList = computed(() => {
  let resList = []
  const screenLevel = info.screenLevel
  if (screenLevel && screenLevel.levelType === 'single' && screenLevel.levelList[0] && screenLevel.levelList[0].isMoreFiled) {
    resList = (screenLevel.levelList[0].moreFiledList || []).map(item => {
      item.isAppenAll === undefined ? false : item.isAppenAll
      return item
    })
  }
  return resList
})

const getScreenRefInfo = computed(() => {
  const list = props.screenRef.map(ref => {
    const obj = { info: ref.info, optionMoreData: ref.optionMoreData }
    if (ref.$refs && ref.$refs.screenTreeRef) {
      obj.screenLevelData = ref.$refs.screenTreeRef.screenLevelData
    }
    return obj
  })
  return list
})

const isSameApp = computed(() => {
  const _info = info.screenLevel
  if (!_info) return true
  if (info.screenLevel.levelType === 'single') {
    const id = levelInfo.value.dataInfo.id || levelInfo.value.dataInfo.approvalId
    const curAppId = props.applyInfo.id || props.applyInfo.approvalId
    return id === curAppId
  }
  return true

})

const btnProps = computed(() => {
  return Object.assign({}, props, attrs, { info })
})

const orgAndRoleSearchList = computed(() => {
  if (isRole.value) {
    const check = info.roleList
    const li = formatRole(roleSearchList.value)
    for (const key in li) {
      // 为了让地址值一样
      const val = li[key]
      const checkItem = check.find(item => item.roleId === val.roleId)
      if (checkItem) {
        li[key] = checkItem
      }
    }
    return li
  } else {
    const check = info.organizationList
    const li = formatOrg(orgSearchList.value)
    for (const key in li) {
      // 为了让地址值一样
      const val = li[key]
      const checkItem = check.find(item => item.organizationId === val.organizationId)
      if (checkItem) {
        li[key] = checkItem
      }
    }
    return li
  }
})

const orgAndRoleAppenText = computed(() => {
  let li = []
  if (isOrganize.value) {
    li = (info.organizationList || []).map(item => getOrgShowName(item))
  } else {
    li = (info.roleList || []).map(item => item.name)
  }
  return li
})

const getFontStyle = computed(() => {
  // 颜色等于#ccc就是默认值不用修改
  const fontStyle = info.fontStyle || props.fontStyle || {}
  if (fontStyle && fontStyle.color === '#ccc') {
    fontStyle.color = '#333'
  }
  return fontStyle
})

const isSelect = computed(() => {
  return info.activeName === 'select'
})

const getControlConfig = computed(() => {
  let item = {}
  try {
    if (isSameApp.value) {
      item = props.addConfig.property.find(c => c.title === info.title)
      if (levelInfo.value.field) {
        const field = levelInfo.value.field.split('_')
        if (field !== info.title) {
          item = props.addConfig.property.find(c => c.title === field[0])
        }
      }
    } else {
      let property = optionApproval.value.property
      property = typeof property === 'string' ? JSON.parse(property) : property
      const field = levelInfo.value.field.split('_')
      if (property) {
        item = property.find(c => c.title === field[0])
      }
    }
  } catch (error) {
    return item
  }
  return item || {}
})

const userConditionFn = computed(() => {
  return control('relation-user', true)
})

const orgConditionFn = computed(() => {
  return control('organization')
})

const isBetween = computed(() => {
  return conditionValue.value === 'between'
})

const isNewRelRadio = computed(() => {
  return ['new-rel-radio'].indexOf(currentType.value) !== -1
})

const isDate = computed(() => {
  return ['date', 'timeof', 'dates'].indexOf(currentType.value) !== -1
})

const isNum = computed(() => {
  return currentType.value === 'number'
})

const isUser = computed(() => {
  let flag = ['relation-user', 'appuser'].indexOf(currentType.value) !== -1
  if (info.screenLevel && info.screenLevel.levelType === 'multiple') {
    // 多级就直接返回了
    return flag = false
  }
  return flag
})

const isOrganize = computed(() => {
  return ['organization'].indexOf(currentType.value) !== -1
})

const isRole = computed(() => {
  return ['role'].indexOf(currentType.value) !== -1
})

const isOrganization = computed(() => {
  return currentType.value === 'organization'
})

const isThisSource = computed(() => {
  let flag = true
  const screenLevel = info.screenLevel
  if (screenLevel && screenLevel.levelType === 'single' && screenLevel.levelList.length > 0) {
    const { dataInfo } = screenLevel.levelList[0]
    if (props.applyInfo.id !== dataInfo.id || props.applyInfo.datatype !== dataInfo.datatype) {
      flag = false
    }
  }
  return flag
})

const isUserSel = computed(() => {
  return conditionValue.value !== 'vacant' && conditionValue.value !== 'noVacant' && conditionValue.value !== 'curuser'
})

const isAppenDropDown = computed(() => {
  return isUser.value && info.showMethods === 'tranL' && isUserSel.value
})

const isDefault = computed(() => {
  return ['orders', 'status', 'text', 'textarea', 'radio', 'checkbox', 'richTextWid', 'relation-check', 'label'].indexOf(currentType.value) !== -1
})

const isControlList = computed(() => {
  return ['text', 'textarea', 'richTextWid', 'new-rel-radio', 'relation-check', 'label'].indexOf(currentType.value) !== -1
})

const isTextSearch = computed(() => {
  return info.activeName === 'text'
})

const isDefaultFilterOpt = computed(() => {
  return info.textFilterOpt === 'opt'
})

const defalutOption = computed(() => {
  const name = info.activeName
  let list = []
  if (isDefault.value) {
    if (name === 'select') {
      if (currentType.value === 'status' && isDefaultFilterOpt.value) {
        list = info.textDataSelShow.map(item => {
          return statusMap[item] || item
        })
      } else {
        if (isControlList.value) {
          list = controlList.value
        } else {
          list = radioList.value
        }
      }
      if (currentType.value === 'radio' && typeof list[0] === 'object') {
        list = list.map(item => item.value)
      }
    } else if (name === 'text') {
      list = []
    } else if (name === 'custom') {
      list = info.customOption.map(item => {
        if (info.customOptionType === 'option') {
          return item.label
        } else if (info.customOptionType === 'check') {
          return item.value
        } else {
          return item
        }
      })
    } else if (name === 'dictionary') {
      list = info.FilterCustomize.length > 0 ? info.FilterCustomize : info.textDataSelShow
    }
  } else if (isUser.value) {
    list = linkUserList.value.map(c => {
      return {
        value: c.realname,
        userId: c.userId
      }
    })
  }
  return list
})

const optSearchList = computed(() => {
  let result = []
  if (defalutOption.value) {
    if (optSearch.value) {
      result = defalutOption.value?.filter(item => isObject(item) ? item.value.includes(optSearch.value) : item.includes(optSearch.value))
    } else {
      result = defalutOption.value?.filter(item => (item || item === 0))
    }
  }
  return result
})

const looperOption = computed(() => {
  if (isDate.value) {
    return dateConditionFn()
  } else if (isNum.value) {
    return numConditionFn()
  } else if (isUser.value) {
    return userConditionFn.value
  } else if (isOrganize.value || isRole.value) {
    return orgConditionFn.value
  } else {
    return []
  }
})

const isOld = computed(() => {
  return !info.isNew
})

const isMultiple = computed(() => {
  return info.filterMode !== 'single'
})

const isOptSearch = computed(() => {
  return info.filterMode === 'search'
})

const customDataList = computed(() => {
  let arr = []
  if (props.customDeskId) {
    arr = store.state.doorCustomDataObj[props.customDeskId] || []
  }
  return arr
})


// Methods
const goOptSearchUser = async function () {
  const query = {
    pagesize: 0,
    curpage: 0,
    names: userSelectText.value
  }
  if (userSelectText.value === '') {
    info.organize = []
    dealCondition(conditionValue.value)
    return
  }
  const res = await getopenuserlist(query)
  let li = []
  if (res.code === 0) {
    li = res.data.map(c => {
      return {
        realname: c.realname,
        userId: c.userId
      }
    })
    // 没有数据的时候显示为空
    if (li.length === 0) {
      li = [{ name: '', userId: '-1' }]
    }
  }
  info.organize = li
  dealCondition(conditionValue.value)
}

const getOptionConfig = async function () {
  if (!isSameApp.value) {
    const approvalId = levelInfo.value.dataInfo.id || levelInfo.value.dataInfo.approvalId
    if (!approvalId) return
    const __par = { approvalId }
    if (isUpace.value) {
      let upaceId = typeof (route.query.upaceid) !== 'undefined' ? route.query.upaceid : localStorage.getItem('upaceid')
      __par.upaceid = upaceId
    }
    const { code, data } = await openapiGetapproval(__par)
    if (code === 0) {
      optionApproval.value = data
    }
  }
}

const getOrgOrRoleOpt = async () => {
  if (info.i !== props.noChangeScreenId || !isSameApp.value) {
    let list = []
    let levelList, levelType, isScreenLevel
    if (info.screenLevel) {
      levelList = info.screenLevel.levelList
      levelType = info.screenLevel.levelType
    }
    if (isScreenLevel) {
      list = await getDataSoureOptions(5000)
    } else {
      list = await getAppOptions()
    }
    const flag = isObject(list[0])
    const li = list.map(item => {
      if (flag) return item
      else return JSON.parse(item)
    }).flat(1)
    const res = []
    const key = isOrganize.value ? 'organizationId' : 'roleId'
    for (const ele of li) {
      const idx = res.findIndex(f => f[key] === ele[key])
      if (idx === -1) {
        res.push(ele)
      }
    }
    return res
  }
}


const setOrgAndRoleDefault = (list) => {
  const { isAppenAll, defaultSelected = 'first' } = info
  const liKey = isOrganize.value ? 'organizationList' : 'roleList'
  const idKey = isOrganize.value ? 'organizationId' : 'roleId'
  const fn = isOrganize.value ? formatOrg : formatRole
  if (defaultSelected === 'all') {
    info.value = []
    info[liKey] = fn(list)
    orgAndRoleListValue.value = fn(list).map(item => item[idKey])
    if (isAppenAll && isMultiple.value) {
      info.value.push('全部')
    } else if (isAppenAll && !isMultiple.value) {
      info.value = ['全部']
    }
  } else if (defaultSelected === 'null') {
    info.value = []
    info[liKey] = []
    info.organize = []
  } else if (defaultSelected === 'first') {
    if (list.length !== 0) {
      info.value = [fn(list)[0]]
      info.organize = [fn(list)[0]]
      info[liKey] = [list[0]]
    }
  }
}

const getUserDataOpt = async function (isReturn = true) {
  if (info.i !== props.noChangeScreenId || !isSameApp.value) {
    let list = []
    let levelList, isScreenLevel
    if (info.screenLevel) {
      levelList = info.screenLevel.levelList
    }
    if (info.screenLevel && levelList && levelList.length > 0) {
      isScreenLevel = true
    }
    if (isScreenLevel) {
      list = await getDataSoureOptions(5000)
    } else {
      list = await getAppOptions()
    }
    const flag = isObject(list[0])
    const li = list.map(item => {
      if (flag) return item
      else return JSON.parse(item)
    }).flat(1)
    const res = []
    for (const ele of li) {
      const idx = res.findIndex(f => f.userId === ele.userId)
      if (idx === -1) {
        res.push(ele)
      }
    }
    isBottom.value = true
    if (isReturn) {
      return res
    } else {
      linkUserList.value = res
      await setTickList()
    }
  }
}

const setScreenLevel = function () {
  if (info.screenLevel && info.screenLevel.levelList) {
    // 兼容一下父级过滤多选的条件
    const levelList = cloneDeep(info.screenLevel.levelList)
    levelList.forEach((item, index) => {
      if (item.fatherFilterList === undefined && item.fatherField) {
        const title = item.fatherField.split('_')[0]
        const type = item.fatherField.split('_')[2]
        const i = item.dataInfo.allData.findIndex(iter => { return `${iter.title}_${iter.type}` === `${title}_${type}` })
        if (i !== -1) {
          const obj = {
            currentField: item.dataInfo.allData[i],
            fatherField: levelList[index - 1].field || '',
            ov: 'eq'
          }
          item.fatherFilterList = [obj]
        }
      }
    })
    info.screenLevel.levelList = levelList
  }
}

const handleNodeClick = function (data) {
  if (data.parentLable) {
    retractShowValue.value = [data.parentLable.join('/') + '/' + data.label]
  }
  // checkSingle(data.label)
}

const handleNodeCheck = function ({ filterValueObj, lableValueObj, isInit }) {
  retractShowValue.value = []
  if (Array.isArray(filterValueObj) && filterValueObj.length > 0) {
    // 旧的一对一筛选
    filterValueObj.forEach(item => {
      retractShowValue.value.push(item.parentLable.join('/') + '/' + item.label)
    })
    const dates = filterValueObj.map(item => { return item.label })
    checkChange(dates)
  } else if (typeof filterValueObj === 'object') {
    multipleLevelDealDefaultDate(filterValueObj, lableValueObj, isInit)
  }
}

const getUserLink = async function (val) {
  if (!val) return
  if (!isUser.value && info.showMethods !== 'tranL' && Object.keys(val) === 0) return
  const formdata = cloneDeep(props.addConfig.formdata)
  for (const i in val) {
    // 判断是否明细
    if (i.includes('details') && i.split('.').length !== 1) {
      const its = i.split('.')
      formdata[its[0]][0][its[1]] = val[i]
    } else if (i.includes('ready-widget')) {
      // 判断是否为预约控件
      const obj = val[i]
      for (const idx in formdata[i]) {
        formdata[i][idx] = {
          ...formdata[i][idx],
          ...obj[idx]
        }
      }
    } else {
      // 不是明细直接赋值
      formdata[i] = val[i]
    }
  }
  // eslint-disable-next-line vue/no-mutating-props
  props.addConfig.formdata = formdata
  const { list: res, isLinked } = await getLinkUserList()
  if (res.length === 0) {
    isBottom.value = true
  }
  if (userCurpage.value === 1 || isLinked) {
    linkUserList.value = res
  } else {
    linkUserList.value.push(...res)
  }
  await setTickList()
  if (res[0] && !isItManual.value) {
    setUserDefault(res)
  }
  return true
}

const setUserDefault = function (list) {
  const { isAppenAll, defaultSelected = 'first' } = info
  if (defaultSelected === 'all') {
    info.value = []
    userList.value = []
    if (isAppenAll && isMultiple.value) {
      info.value.push('全部')
    } else if (isAppenAll && !isMultiple.value) {
      info.value = ['全部']
    }
  } else if (defaultSelected === 'null') {
    info.value = []
    userList.value = []
    info.organize = []
  } else if (defaultSelected === 'first') {
    if (isAppenAll) {
      info.value = ['全部']
      info.organize = []
      userList.value = []
    } else if (list.length !== 0) {
      info.value = [{ value: list[0].realname, userId: list[0].userId }]
      info.organize = [{ realname: list[0].realname, userId: list[0].userId }]
      userList.value = [list[0].userId]
    }
  }
}

const onCondition = function (item) {
  if (item.dataconfig && item.dataconfig.setUpValue == 1) {//如果有配置联动
    let param = false
    if (item.dataconfig.linked && item.dataconfig.linked.conditional) {
      param = linkedSetEvent(item.dataconfig, props.addConfig.formdata, { index: item.thisIndex })
      if (param) {
        delete param.dataconfig
      }
    }
    item.condition = param ? param : {}//有配置联动，数据没填完使用
  }
  return JSON.parse(JSON.stringify(item))
}

const userCheckCallback = function (e) {
  const { user } = e
  const arr = user.map(c => {
    return {
      userId: c.userId,
      realname: c.realname
    }
  })
  if (isMultiple.value) {
    info.organize.push(...arr)
  } else {
    if (arr[0]) {
      info.organize = [arr[0]]
    }
  }
  isAppenUserPop.value = false
  dealCondition(conditionValue.value)
  userSelectText.value = ''
}

const isObject = function (val) {
  return val !== null && typeof val === 'object'
}

const changeTab = function (type) {
  const all = singleItemAll.value
  const list = [all, ...singleItem.value]
  const verticalL = verticalLItem.value
  if (!verticalL) return
  const scrollWidth = verticalL.scrollWidth
  const totalWidth = verticalL.getBoundingClientRect().width
  const maxTransfromX = -scrollWidth + totalWidth
  const curIdx = transformIdx.value
  let transformIdx = transformIdx.value
  let transformX = transformX.value
  let curWidth = 0
  isMin.value = false
  isMax.value = false
  const isLeft = type === 'left'
  isLeft ? transformIdx-- : transformIdx++
  const curItem = list[curIdx]
  if (curItem) {
    const el = curItem.$el ? curItem.$el : curItem
    curWidth = el.getBoundingClientRect().width
  }
  if (transformIdx === 0) {
    curWidth += 12
  } else {
    curWidth += 24
  }
  if (isLeft && transformIdx > 0) {
    transformX += curWidth
  } else if (!isLeft && transformIdx < list.length) {
    transformX -= curWidth
  }
  if (transformIdx <= 0) {
    // 最小
    transformX = 0
    transformIdx = 0
    isMin.value = true
  }
  if (transformX < maxTransfromX) {
    // 最大
    transformX.value = maxTransfromX
    isMax.value = true
    return
  }
  transformIdx.value = transformIdx
  transformX.value = transformX
}

const isAppenTabMenthod = function () {
  setTimeout(() => {
    const verticalL = verticalLItem.value
    if (!verticalL) return
    const scrollWidth = verticalL.scrollWidth
    const totalWidth = verticalL.getBoundingClientRect().width
    if (scrollWidth > Math.ceil(totalWidth)) {
      isAppenTab.value = true
    }
  }, 500);
}

const getRadioList = async function () {
  // isScreenLevel 如果为true 就要使用新配置的数据源里面的东西
  let levelList, isScreenLevel, title, type, dataInfo
  if (info.screenLevel) {
    levelList = info.screenLevel.levelList
  }
  if (info.screenLevel && levelList && levelList.length > 0) {
    isScreenLevel = true
  }
  const param = {
    approvalId: props.applyInfo.id,
    feild: info.title
  }

  if (isScreenLevel) {
    const { field } = levelList[0]
    dataInfo = levelList[0].dataInfo
    if (field) {
      title = dataInfo.datatype === 1 ? field.split('_')[0] : field.split('_')[1] // 当前表要使用的字段
      type = field.split('_')[2]
      if (dataInfo.datatype === 1 && field) {
        param.feild = title
        param.approvalId = dataInfo.id
      }
    }
  }
  let list = []
  if (param.feild.includes('ready-widget')) {
    if (currentType.value !== 'status' && typeof info.textDataSelShow[0] === 'object') {
      list = info.textDataSelShow.map(c => c && c.label).filter(c => c)
    } else {
      if (isScreenLevel) {
        list = await getDataSoureOptions() // 获取设置的数据源的数据值
      } else {
        list = await getAppOptions()
      }
    }
    return list
  }
  if (isDefaultFilterOpt.value) {
    let res = unconditionalLinkageData.value
    if (Object.keys(res).length === 0 && dataInfo.datatype === 1) {
      res = await axiosBase(param, 'api/getradiodata')
      unconditionalLinkageData.value = res
    }
    if (res.code === 0 && res.data.length !== 0) {
      list = res.data
    } else {
      let li = info.textDataSelShow
      const allData = props.applyInfo && props.applyInfo.allData ? props.applyInfo.allData : []
      const index = allData.findIndex(item => { return `${title}_${type}` === `${item.title}_${item.type}` })
      let sels
      if (index !== -1) {
        sels = getControlConfig.value.sels
      } else if (isScreenLevel && dataInfo && dataInfo.datatype === 1) {
        let property = []
        if (dataInfo.id === props.applyInfo.id) {
          property = props.addConfig.property
        } else {
          const res = await openapiGetapproval({ approvalId: dataInfo.id }).catch(err => { console.log(err) })
          if (res.code === 0) {
            property = JSON.parse(res.data.property)
          }
        }
        const filedItem = property.find(item => { return `${title}_${type}` === `${item.title}_${item.type}` })
        if (filedItem && filedItem.sels) {
          sels = filedItem.sels
        }
      }
      if (sels) {
        sels = typeof sels === 'string' ? JSON.parse(sels) : sels
        li = sels
      }
      if (currentType.value !== 'status' && typeof li[0] === 'object') {
        list = li.map(c => c && c.label).filter(c => c)
      } else {
        list = li.filter(c => c)
      }
    }
  } else {
    if (isScreenLevel) {
      list = await getDataSoureOptions() // 获取设置的数据源的数据值
    } else {
      list = await getAppOptions()
      if (param.feild === 'status' && list.length > 0) {
        list = list.map(item => {
          return statusText[item] || item
        })
      }
      if (param.feild === 'archive') {
        list = ['未归档', '已归档']
      }
    }
  }
  return list
}

const checkSingle = function (item) {
  let list = []
  if (item === '全部') {
    info.value = ['全部']
    list = optSearchList.value
    info.checkAll = true
    if (isUser.value) {
      info.organize = optSearchList.value
    }
  } else {
    list = [item]
    info.value = list
    info.checkAll = false
  }
  if (isUser.value) {
    // 把联系人控件也写入默认  每次改变的时候也要去改变联系人储存值
    isItManual.value = true
    let user = defalutOption.value.find(c => c.userId === item.userId)
    user = cloneDeep(user)
    if (user) {
      user.realname = user.value
      delete user.value
      info.organize = [user]
    }
    dealCondition(conditionValue.value)
  } else {
    dealDefaultDate(list)
  }
}

const getDataSoureOptions = async function (pageSize = 1000) {
  // 是否为 watch 那边走过来
  optionMoreData.value = {}
  const { levelList, levelType } = info.screenLevel
  const len = levelList.length
  const config = levelList[len - 1]
  const { field, dataInfo, isMoreFiled } = config
  if (!field) return []
  const totalParams = props.applyInfo.id === dataInfo.id ? cloneDeep(props.totalParams) : {}
  const title = dataInfo.datatype === 1 ? field.split('_')[0] : field.split('_')[1] // 当前表要使用的字段
  const type = field.split('_')[2]
  let list = []
  if (field === '状态_状态_status') {
    return ['进行中', '已通过', '未通过', '已撤回']
  } else if (field && field.search('归档状态') !== -1) {
    return ['已归档', '未归档']
  }
  // 联系人也走这边
  // info.textFilterOpt === 'data' 先不区分数据值和选项值
  if (info.textFilterOpt || ['relation-user', 'organization', 'roule'].includes(type)) {
    list = await getData({ config: cloneDeep(config), totalParams: totalParams, levelType: levelType, pageSize, screenRefValue: getScreenRefInfo.value })
    let _list = []
    list.forEach(item => {
      let key = item[title]
      if (Array.isArray(item[title])) {
        _list.push(...item[title])
        item[title].forEach(iten => {
          key = iten
          if (typeof iten === 'object') {
            key = `${iten.realname || iten.name}_${iten.userId || iten.organizationId || iten.roleId}`
          }
          setOptionMoreData(key, item)
        })
      } else {
        _list.push(item[title])
        setOptionMoreData(key, item)
      }
    })
    list = [...new Set(_list)]
    if (Object.keys(optionMoreData.value).length > 0) {
      optionMoreChildrenData.value = cloneDeep(optionMoreData.value)
    }
  } else {
    // 选项值
    list = await getAppOptions() || []
  }
  return list || []
}
const setOptionMoreData = (key, data) => {
  // 如果出现第二条主筛选的数据
  if (optionMoreData.value[key]) {
    for (const dataKey in data) {
      // 主数据源就不要重复赋值了
      const dataKeyValue = data[dataKey]
      if (dataKeyValue !== dataKey) {
        // 主筛选的同一个值可能有多条 要把不同数据的子筛选给合并在一起
        if (optionMoreData.value[key][dataKey]) {
          let moreDataValue = Array.isArray(optionMoreData.value[key][dataKey]) ? cloneDeep(optionMoreData.value[key][dataKey]) : [cloneDeep(optionMoreData.value[key][dataKey])]
          // 子数据是数组的情况
          if (Array.isArray(dataKeyValue)) {
            // 联系人或者组织角色的处理
            if (typeof dataKeyValue[0] === 'object') {
              // 根据id去重
              const idKey = dataKeyValue[0].organizationId ? 'organizationId' : (dataKeyValue[0].roleId ? 'roleId' : 'userId')
              const mergedArray = [...moreDataValue, ...dataKeyValue];
              moreDataValue = uniqBy(mergedArray, idKey);
            } else {
              // 多选、日期等类型的处理
              moreDataValue = Array.from(new Set([...moreDataValue, ...dataKeyValue]))
            }
          } else {
            // 正常文本数字的处理
            if (!moreDataValue.includes(dataKeyValue)) {
              moreDataValue.push(dataKeyValue)
            }
          }
          optionMoreData.value[key][dataKey] = moreDataValue
        }
      }
    }
  } else {
    optionMoreData.value[key] = data
  }
}

const getAppOptions = async function (_params) {
  if (skey.value && !localStorage.getItem('user')) return []
  const totalParam = cloneDeep(props.totalParams)
  const key = totalParam.key
  const params = totalParam.params || {}
  const status = totalParam.status
  let query = {}
  let ruledata = {}
  if (_params) {
    params.groupfield = _params.groupfield
    params.curpage = 1
    params.pagesize = 1
    query = totalParam.query
    ruledata = totalParam.ruledata
  } else {
    query = totalParam.query
    ruledata = totalParam.ruledata
    if (info.title === '状态' || info.title === 'status') {
      params.groupfield = `status_${currentType.value}`
    } else if (info.title !== '单号') {
      params.groupfield = `${info.title}_${currentType.value}`
    }
  }
  let list = []
  if (currentType.value && currentType.value.includes('ready-widget')) return []
  switch (props.pageId) {
    case '1':
      // 我填报的
      list = await getWriteListInfo(key, query, params, ruledata)
      break
    case '2':
      // 待我处理的
      list = await getPeddingListInfo(key, query, params, ruledata)
      break
    case '3':
      // 待阅
      list = await getTreatViewListInfo(key, query, status, params)
      break
    case '4':
      // 我已处理
      list = await getProcessedListInfo(key, query, params, ruledata)
      break
    case '5':
      // 关于我的
      list = await getAboutMeListInfo(key, query, params, ruledata)
      break
    case '6':
      // 管辖数据
      list = await getAllDataListInfo(key, query, params, ruledata)
      break
    case '7':
      // 全部数据
      list = await getAllDataListInfo(key, query, params, ruledata)
      break
  }
  if (_params && _params.groupfield) {
    if (list && list.length !== 0) {
      list = list[0].groupfield
    } else {
      list = []
    }
    if (_params.groupfield.includes('relation-user')) {
      list = list.map(item => {
        const f = typeof item === 'string' ? JSON.parse(item) : item
        return Array.isArray(f) ? f[0] : f
      })
    }
  } else {
    if (list && list.length !== 0) {
      list = list[0].groupfield
    } else {
      list = []
    }
  }
  if (currentType.value === 'checkbox') {
    const li = []
    for (const ele of list) {
      try {
        const date = JSON.parse(ele)
        li.push(...date)
      } catch (error) {
        li.push(ele)
      }
    }
    list = [...new Set(li)]
  }
  return list || []
}

const getWriteListInfo = async function (key, query, params = {}, ruleData = {}) {
  // 获取我填报的数据
  if (!props.powerData['0'].reportFormId) return []
  const param = {
    type: 0,
    curpage: 1,
    pagesize: 1,
    approvalId: props.applyInfo.id,
    key,
    query,
    reportFormId: props.powerData['0'].reportFormId,
    ...params,
    ...ruleData
  }
  if (spaceid) {
    param.spaceid = spaceid
  }
  else if (upaceid) {
    param.upaceid = upaceid
  }
  if (!param.groupfield) {
    if (info.title === '状态' || info.title === 'status') {
      param.groupfield = `status_${currentType.value}`
    } else if (info.title !== '单号') {
      param.groupfield = `${info.title}_${currentType.value}`
    }
  }
  const res = await axiosBase(param, '/api/getuserfielddatalist')
  if (res.code === 0) {
    return res.data
  }
}

const getPeddingListInfo = async function (key, query, params, ruleData = {}) {
  // 获取待我处理的数据
  if (!props.powerData['0'].reportFormId) return
  const param = {
    type: 1,
    status: '0',
    way: '0,1,2,4',
    curpage: 0,
    pagesize: 0,
    approvalId: props.applyInfo.id,
    key,
    query,
    reportFormId: props.powerData['0'].reportFormId,
    ...params,
    ...ruleData
  }
  if (spaceid) {
    param.spaceid = spaceid
  }
  else if (upaceid) {
    param.upaceid = upaceid
  }
  if (!param.groupfield) {
    if (info.title === '状态' || info.title === 'status') {
      param.groupfield = `status_${currentType.value}`
    } else if (info.title !== '单号') {
      param.groupfield = `${info.title}_${currentType.value}`
    }
  }
  const res = await axiosBase(param, '/api/getuserfielddatalist')
  if (res.code === 0) {
    return res.data
  }
}

const getTreatViewListInfo = async function (key, query, status, params) {
  // 获取待阅的数据
  const param = {
    type: 1,
    way: '0,1,2,4',
    status,
    curpage: 0,
    pagesize: 0,
    key,
    ...query,
    approvalId: props.applyInfo.id,
    ...params
  }
  if (spaceid) {
    param.spaceid = spaceid
  }
  else if (upaceid) {
    param.upaceid = upaceid
  }
  if (!param.groupfield) {
    if (info.title === '状态' || info.title === 'status') {
      param.groupfield = `status_${currentType.value}`
    } else if (info.title !== '单号') {
      param.groupfield = `${info.title}_${currentType.value}`
    }
  }
  const res = await axiosBase(param, '/openapi/getuserccapprovallist')
  if (res.code === 0) {
    return res.data
  }
}

const getProcessedListInfo = async function (key, query, params, ruleData = {}) {
  // 获取我已处理的数据
  if (!props.powerData['0'].reportFormId) return
  const param = {
    type: 1,
    way: '0,1,2,4',
    status: '1,2',
    curpage: 0,
    pagesize: 0,
    approvalId: props.applyInfo.id,
    key,
    query,
    reportFormId: props.powerData['0'].reportFormId,
    ...params,
    ...ruleData
  }
  if (spaceid) {
    param.spaceid = spaceid
  }
  else if (upaceid) {
    param.upaceid = upaceid
  }
  if (!param.groupfield) {
    if (info.title === '状态' || info.title === 'status') {
      param.groupfield = `status_${currentType.value}`
    } else if (info.title !== '单号') {
      param.groupfield = `${info.title}_${currentType.value}`
    }
  }
  const res = await axiosBase(param, '/api/getuserfielddatalist')
  if (res.code === 0) {
    return res.data
  }
}

const getAboutMeListInfo = async function (key, query, params, ruleData = {}) {
  // 获取关于我的数据
  if (!props.powerData['0'].reportFormId) return
  const param = {
    type: 0,
    selfuser: 0,
    curpage: 0,
    pagesize: 0,
    approvalId: props.applyInfo.id,
    key,
    query,
    reportFormId: props.powerData['0'].reportFormId,
    ...params,
    ...ruleData
  }
  if (spaceid) {
    param.spaceid = spaceid
  }
  else if (upaceid) {
    param.upaceid = upaceid
  }
  if (!param.groupfield) {
    if (info.title === '状态' || info.title === 'status') {
      param.groupfield = `status_${currentType.value}`
    } else if (info.title !== '单号') {
      param.groupfield = `${info.title}_${currentType.value}`
    }
  }
  const res = await axiosBase(param, '/api/getuserfielddatalist')
  if (res.code === 0) {
    return res.data
  }
}

const getAllDataListInfo = async function (key, query, params, ruleData = {}) {
  // 获取全部数据
  const pageid = props.pageId
  if (!props.powerData['1'].reportFormId) return
  const param = {
    type: 0,
    curpage: 1,
    pagesize: 1,
    approvalId: props.applyInfo.id,
    key,
    query,
    reportFormId: props.powerData['1'].reportFormId,
    ...params,
    ...ruleData
  }
  if (spaceid) {
    param.spaceid = spaceid
  } else if (upaceid) {
    param.upaceid = upaceid
  }
  if (pageid === '6') {
    param.querys = query
    delete param.query
  }
  if (!param.groupfield) {
    if (info.title === '状态' || info.title === 'status') {
      param.groupfield = `status_${currentType.value}`
    } else if (info.title !== '单号') {
      param.groupfield = `${info.title}_${currentType.value}`
    }
  }
  const res = await axiosBase(param, '/api/getfielddatalist')
  if (res.code === 0) {
    return res.data
  }
}

const getAllOptions = async function (title, type) {
  if (skey.value && !localStorage.getItem('user')) return []
  let val = `${title}_${type}`
  if (title === 'orders') {
    val = '单号_text'
  }
  const param = {
    curpage: 1,
    pagesize: 999,
    text: '',
    title: val,
    approvalId: props.applyInfo.id,
    reportId: 0
  }
  if (route.query.space || route.query.spaceid) {
    let spaceId = typeof (route.query.spaceid) !== 'undefined' ? route.query.spaceid : localStorage.getItem('spaceid')
    param.spaceid = spaceId
  } else if (route.query.upace || route.query.upaceid) {
    let upaceId = typeof (route.query.upaceid) !== 'undefined' ? route.query.upaceid : localStorage.getItem('upaceid')
    param.upaceid = upaceId
  }
  const res = await getapprovalfieldoptions(param)
  if (res.code === 0) {
    return res.data
  } else {
    return []
  }
}

const goOrgAndRoleSearch = async function () {
  const text = orgAndRoleSearchText.value
  if (!text) {
    isOrgAndRoleSearch.value = false
    nextTick(() => {
      showOrgAndRoleList(false)
    })
    return
  } else {
    isOrgAndRoleSearch.value = true
  }
  const param = {
    name: text,
  }
  if (isDefaultFilterOpt.value) {
    if (isOrganize.value) {
      const list = await getOrgList(param)
      orgSearchList.value = list
    } else {
      const list = await getopenrolelist(param)
      roleSearchList.value = list
    }
  } else {
    const li = orgAndRoleList.value.filter(item => {
      if (isOrganize.value) {
        return item.name.indexOf(text) > -1 || getOrgShowName(item).indexOf(text) > -1
      } else {
        return item.name.indexOf(text) > -1
      }
    })
    if (isOrganize.value) {
      orgSearchList.value = li
    } else {
      roleSearchList.value = li
    }
  }
}

const showOrgAndRoleList = function (flag) {
  const selectRef = orgSelectRef.value
  if (selectRef && userPopWidth.value === 300) {
    userPopWidth.value = selectRef.getBoundingClientRect().width
  }
  const data = getControlConfig.value
  const opt = {
    id: isSameApp.value ? props.applyInfo.id : levelInfo.value.dataInfo.id,
    data,
  }
  let ref = organizeRef.value
  if (ref) {
    let options = {}
    let type = 'JsonDataOrg'
    if (isOrganize.value) {
      ref = organizeRef.value
      const li = formatOrg(info.organizationList)
      opt.info = li
      options.checkedArr = li
    } else if (isRole.value) {
      ref = roleRef.value
      const li = formatRole(info.roleList)
      opt.info = li
      options.checkedArr = li
      type = 'JsonDataRole'
    }
    const param = getUserParam(opt)
    options = { ...options, apiurl: param.apiurl, onlyUser: false, option: param.lookCustomArr, leaf: param.leafOrg, radio: false, isdoorMultiple: isMultiple.value }
    ref.fromParent(param[type], options)
  }
  if (flag === false) return
  isAppenPop.value = !isAppenPop.value
}

const orgAndRoleSearchClick = function (item) {
  const type = isOrganize.value ? 'organization' : 'role'
  changeCheck([item], type)
}

const changeCheck = function (val, type = 'organization') {
  let list = []
  if (type === 'organization') {
    if (isDefaultFilterOpt.value) {
      list = formatOrg(val)
    } else {
      list = val
    }
    if (val[0] === '全部') {
      list = orgAndRoleList.value
    }
    info.organizationList = list
    info.organize = list
  } else {
    if (val[0] === '全部') {
      list = orgAndRoleList.value
    }
    list = formatRole(val)
    info.roleList = list
  }
  dealCondition(conditionValue.value)
}

const showList = async function (isAppen = false, isExpandSelect = false) {
  // text radio checkbox 类型走下面
  if (isUser.value) return
  if (isAppenPop.value && !info.checkTips && !isExpandSelect) {
    isAppenPop.value = false
    return
  }
  let list = []
  const showRef = defaultShowRef.value
  if (showRef && showRef.$el) {
    userPopWidth.value = showRef.$el.getBoundingClientRect().width
  }
  if (isMultipleLevel.value) {
    // TODO
  } else if (isSelect.value) {
    if (props.noChangeScreenId !== info.i) {
      if (isControlList.value) {
        if (info.screenLevel && info.screenLevel.levelType === 'single' && info.screenLevel.levelList.length > 0) {
          const list = await getDataSoureOptions() // 获取设置的数据源的数据值
          controlList.value = list
        } else {
          list = await getAppOptions()
          if (list.length === 0) {
            controlList.value = await getAllOptions(info.title, currentType.value)
          } else {
            controlList.value = list
          }
        }
      } else {
        radioList.value = await getRadioList()
      }
    }
  }
  // 重新定位一下下来框的位置
  // if (popoverRef.value) {
  //   popoverRef.value.updatePopper()
  // }
  if (Boolean(isAppen) || isExpandSelect) {
    isAppenPop.value = true
    setTimeout(() => {
      if (popInput.value) popInput.value.focus()
    }, 100)
  }
}

const putItAwayList = function () {
  const ref = tranLopt.value
  const height = ref.getBoundingClientRect().height
  if (height === 0) {
    // 说明是收缩状态
    ref.style.height = '100%'
    isShrink.value = false
  } else {
    ref.style.height = 0
    isShrink.value = true
  }
}

const watchScrollToBootom = function () {
  setTimeout(() => {
    if (!isThisSource.value) return
    const ref = scrollbarRef.value
    if (!ref) return
    const scrollbarEl = ref.$refs.wrapRef
    if (!scrollbarEl) return
    scrollbarEl.onscroll = (el) => {
      if (isScrollAtBottom(el)) {
        if (isBottom.value) return
        userCurpage.value++
        getUserLink({})
      }
    }
  }, 500)
}


const customCheckChange = (val) => {
  dealDefaultDate([val])
}
const expandSelect = (isParent = false) => {
  isParentExpand.value = isParent
  showList(true, true)
}
const screenItemChange = (value, screenItemInfo, options) => {
  const screenValue = info.value || []
  if (value.length !== 0
    || screenValue.length === 0
    || (value.length === 0 && options.length === 0 && !screenItemInit.value[screenItemInfo.title])) {
    screenValue.forEach(item => {
      if (optionMoreData.value[item]) {
        const key = optionMoreData.value[item][screenItemInfo.title] ? screenItemInfo.title : screenItemInfo.name
        if (optionMoreData.value[item][key] !== undefined) {
          optionMoreData.value[item][key] = value
        }
      }
    })
    screenItemInit.value[screenItemInfo.title] = true
    dealDefaultDate(info.value)
  }
}
const getScreenItemOpt = (item) => {
  let value = info.value
  const options = []
  if (info.value[0] === '全部') {
    value = defalutOption.value
  }
  for (const ele of value) {
    let val = ''
    if (isDefault.value) {
      if (optionMoreChildrenData.value[ele]) {
        val = optionMoreChildrenData.value[ele][item.title]
        if (val === undefined) {
          val = optionMoreChildrenData.value[ele][item.name]
        }
      }
      if (item.type === 'checkbox' && Array.isArray(val)) {
        val = val.map(c => isObject(c) ? c.value : c)
      }
    }
    if (val) {
      if (Array.isArray(val)) {
        options.push(...val)
      } else {
        options.push(val)
      }
    }
  }
  return options
}
const orgMutualCheck = (item) => {
  const li = []
  const idKey = isOrganize.value ? 'organizationId' : 'roleId'
  const type = isOrganize.value ? 'organization' : 'role'
  for (const ele of item) {
    const value = orgAndRoleList.value.find(c => c[idKey] === ele)
    if (value) {
      li.push(value)
    }
  }
  changeCheck(li, type)
}
const showOrgName = (item) => {
  if (isOrganize.value) {
    return getOrgShowName(item)
  } else {
    return item.name
  }
}
const isActiveRoleAndOrg = (item) => {
  const liKey = isOrganize.value ? 'organizationList' : 'roleList'
  const key = isOrganize.value ? 'organizationId' : 'roleId'
  const li = info[liKey] || []
  if (item === '全部' && li.length === orgAndRoleList.value.length) return true
  for (const ele of li) {
    if (ele[key] === item[key] && li.length !== orgAndRoleList.value.length) {
      return true
    }
  }
}

const init = async function (isParent = false, triggerId) {
  // isParent 是否父组件调用
  let initDate = cloneDeep(info.value) || []
  conditionValue.value = info.conditionValue.val
  let defaultSelected = info.defaultSelected || (props.isAppDesign ? 'all' : 'first')
  const _skey = route.query.skey || route.params.skey
  if (_skey) {
    skey.value = _skey
  }
  if (info.showMethods === 'verticalL' && info.activeName !== 'text') {
    isAppenTabMenthod()
  }
  if ((isOrganize.value || isRole.value) && info.showMethods === 'tranL') {
    // 横向展开 重新请求一下
    nextTick(showOrgAndRoleList)
  }

  if (props.isInit === false) {
    // 是否初始化数据
    emit('close-loading', info.i)
    isData.value = false
  }

  if (isDate.value || isNum.value || isUser.value) {
    if (isUser.value && info.showMethods === 'tranL') {
      let list = []
      if (isThisSource.value) {
        if (isDefaultFilterOpt.value) {
          // 选项值
          const { list: res } = await getLinkUserList()
          list = res
        } else {
          // 数据值
          list = await getUserDataOpt()
        }
      } else {
        list = await getDataSoureOptions()
      }
      linkUserList.value = list
      await setTickList()
      setUserDefault(list)
    }
    if (isDate.value && Object.keys(info.conditionValue).length === 0) {
      conditionValue.value = 'thatDay'
    }
    nextTick(watchScrollToBootom)
    if (!isMultipleLevel.value) dealCondition(conditionValue.value, true)
  } else if (isOrganize.value || isRole.value) {
    if (!isMultipleLevel.value && (isOrganize.value || isRole.value)) {
      let list = []
      if (isThisSource.value) {
        if (isDefaultFilterOpt.value) {
          // 选项值
        } else {
          // 数据值
          list = await getOrgOrRoleOpt()
        }
      } else if(props.isLeft === true ) {
        list = await getDataSoureOptions()
      }
      await setTickList()
      orgAndRoleList.value = list
      setOrgAndRoleDefault(list)
    }
    if (isOrganize.value) {
      const li = formatOrg(info.organizationList)
      info.organizationList = li
    } else {
      const li = formatRole(info.roleList)
      info.roleList = li
    }
    console.log(info.organizationList,'lilililili')
    dealCondition(conditionValue.value, true)
  } else if (isDefault.value) {
    if (info.screenLevel && info.screenLevel.levelType === 'multiple') {
      // TODO
    } else if (isSelect.value) {
      if (props.noChangeScreenId !== info.i || isParent) {
        if (isControlList.value) {
          if (info.screenLevel && info.screenLevel.levelType === 'single' && info.screenLevel.levelList.length > 0) {
            if (isParent) {
              relationScreenInit.value[triggerId] = true
            }
            if (relationScreen.value.length === 0 || Object.keys(relationScreenInit.value).length === relationScreen.value.length) {
              const list = await getDataSoureOptions() // 获取设置的数据源的数据值
              controlList.value = list
            } else {
              controlList.value = []
            }
          } else {
            // 是否根据列表显示数据
            const list = await getAppOptions()
            if (list.length === 0) {
              controlList.value = await getAllOptions(info.title, currentType.value)
            } else {
              controlList.value = list
            }
          }
        } else {
          radioList.value = await getRadioList()
        }
      }
    }
    if (info.activeName === 'dictionary') {
      const list = await getDictionaryData()
      info.FilterCustomize = list
    }

    if (['select', 'dictionary', 'custom'].includes(info.activeName)) {
      await setTickList()
    }

    let list = cloneDeep(info.value)
    if ((Array.isArray(info.bindField) && info.bindField.length !== 0) || (!Array.isArray(info.bindField) && info.bindField)) {
      let bindField = cloneDeep(info.bindField)
      if (Array.isArray(bindField)) {
        bindField = info.bindField[0]
      }
      let val = await getBindFiledData(bindField)
      if (Array.isArray(info.bindField) && info.bindField[1] && isStandardClass(val, 'class')) {
        val = getClassInfo(val, info.bindField[1])
      }
      if (info.value && Array.isArray(info.value) && info.bindField && (val || val === 0)) {
        info.value = [val]
      }
      if (isTextSearch.value) {
        searchValue.value = val
      }

      if (val) {
        list = info.value
      }
      initDate = info.value
    }
    if (info.checkName === '归档') {
      initDate = cloneDeep(info.FilterValue) || []
    }
    if (defaultSelected === 'all') {
      info.value = initDate
      list = initDate.filter(item => item !== '全部')
      if (info.checkAll && info.isAppenAll) {
        list = defalutOption.value.filter(item => item !== '全部')
        info.value.push('全部')
      }
    } else if (defaultSelected === 'null' && !isMultipleLevel.value) {
      info.checkAll = false
      info.value = []
      list = []
    } else if (defaultSelected === 'first') {
      if (info.isAppenAll) {
        info.checkAll = true
        info.value = ['全部']
        list = defalutOption.value
      } else {
        info.checkAll = false
        info.value = defalutOption.value[0] ? [defalutOption.value[0]] : []
        list = info.value
      }
    }
    if (isCustomCheck.value && info.value.length === 0) {
      info.value = defalutOption.value[1] ? [defalutOption.value[1]] : []
      list = info.value
    }
    dealDefaultDate(list, true)
  } else if (isNewRelRadio.value) {
    await nextTick()
    setTimeout(async () => {
      const list = await getNewRelRadioList()
      newRelRadioList.value = list
      dealDefaultDate(info.value, true)
    }, 800);
  }
  // 初始化的时候如果是空值、收起状态且设置了选择提示
  if (props.isInit && info.showMethods === 'putItAway' && info.checkTips && defalutOption.value.length > 0) {
    expandSelect()
  } else {
    document.addEventListener('click', closePop)
  }
}

const closePop = function () {
  isAppenPop.value = false
  isAppenUserPop.value = false
}

const setTickList = async function () {
  if (!levelInfo.value.tagList && !levelInfo.value.tagInfo) return
  if (props.applyInfo && !(props.applyInfo.id || props.applyInfo.approvalId)) return false
  let value = defalutOption.value
  if (info.firstScreenField) {
    value = getRealScreenValue({ value }).value
  }
  const query = [
    {
      field: `${info.title}_${info.screenType}`,
      value,
      relation: 'in'
    }
  ]
  const param = {
    query,
    curpage: 1,
    pagesize: 9999,
    text: '',
    title: `${info.title}_${info.screenType}`,
    approvalId: props.applyInfo.id,
    reportId: 0
  }
  const li = await getFileterList(param)
  tickList.value = li
}

const changeNewRelRadio = async function (e) {
  let config = getControlConfig.value
  let item = newRelRadioList.value.find(val => {
    if (e === val.approvingId) {
      return val
    }
  })
  let types = config.title + '_' + config.type;
  const formdata = {}
  if (config.selectTable && config.selectTable === 'sys') {
    // 工坊先不管
    if (config.relFormId === 'user') {
      // 用户表图片格式固定的
      e.facephoto = e.facephoto ? [{ Response: e.facephoto, url: $vm.$imgurl + e.facephoto, name: (e.facephoto).split('-').at(-1) }] : []
      e.avatar = e.avatar ? [{ Response: e.avatar, url: $vm.$imgurl + e.avatar, name: (e.avatar).split('-').at(-1) }] : []
      if (JSON.stringify(userType) !== '{}') e.type = userType[e.type] || '无类型'
    } else {
      e.type = dealType(e.type)
    }
    item = e
  } else if ((!config.selectTable || config.selectTable === 'customization') && (!config.isSource || config.isSource === 1)) {
    // 应用
    formdata[types] = item.自定义标题;
  }
  if (config.list && config.list.length > 0) {
    let list = config.list;
    for (let i = 0; i < list.length; i++) {
      let listType = list[i].title + '_' + list[i].type;
      const isSource = config.selectTable && config.selectTable === 'customization' && config.isSource && config.isSource === 2 ? list[i].name : config.selectTable && config.selectTable === 'sys' ? list[i].field : ''
      // 多选框要改成数组格式
      if (list[i].type === 'checkbox') {
        try {
          formdata[listType] = JSON.parse(!isSource && item ? item[list[i].titleId] : item[isSource]);
        }
        catch (e) {
          formdata[listType] = !isSource && item ? item[list[i].titleId] : item[isSource];
        }
        if (typeof item[list[i].titleId] === 'string') {
          let listVal = [];
          try {
            listVal = (!isSource && item ? item[list[i].titleId] : item[isSource]).split(',');
          }
          catch (e) {
            console.log('转格式错误')
          }
          formdata[listType] = listVal;
        }
      } else if (list[i].type === 'relation-user') {
        try {
          formdata[listType] = JSON.parse(!isSource && item ? item[list[i].titleId] : item[isSource]);
        }
        catch (e) {
          formdata[listType] = !isSource && item ? item[list[i].titleId] : item[isSource];
        }
      } else {
        formdata[listType] = !isSource && item ? item[list[i].titleId] : item[isSource];
      }
    }
  }
  newRelRadioCover.value = formdata
  const data = cloneDeep(formdata)
  for (const key in data) {
    const ele = data[key]
    if (!ele) {
      delete data[key]
    }
  }
  emit('change-new-rel-radio', data, info.i)
}

const dealType = function (type) {
  const itype = organizationType.value.find(item => item.deptTipId === type) || {}
  return itype.name
}

const selectFocus = function (e) {
  if (e) {
    const w = e.target.getBoundingClientRect()
    widthOption.value = w.width
  }
}

const getNewRelRadioList = async function () {
  if (skey.value && !localStorage.getItem('user')) return []
  const config = getControlConfig.value
  const param = onCondition(config)
  let list = []
  let par = {}
  if (param && param.relWidDataLook) {
    par = {
      relWidDataLook: param.relWidDataLook,
      approvalId: config.relFormId,
      datahided: config.datahided,
      appid: props.applyInfo.id,
      curpage: 0,
      pagesize: 0,
      type: 0,
      cateId: -1
    }
    if (param.dataconfig) par.dataconfig = JSON.stringify(param.dataconfig);
    if (param.condition) par.condition = JSON.stringify(param.condition);
  } else {
    par = {
      relWidDataLook: config.relWidDataLook ? config.relWidDataLook : 1,
      approvalId: config.relFormId,
      curpage: 0,
      pagesize: 0,
      datahided: config.datahided,
      appid: props.applyInfo.id,
      query: "{}",
      key: '',
    }
    //如果有联动，需要回父级调用联动
    if (config.dataconfig && config.dataconfig.setUpValue == 1) {
      par.dataconfig = JSON.stringify(config.dataconfig)
      par.condition = JSON.stringify(config.condition)
    }
  }
  if (config.selectTable && config.selectTable === 'sys' && config.relFormId === 'org') {
    if (organizationType.value.length === 0) getOrganizationType()
    list = await getOrgList()
  } else if (config.selectTable && config.selectTable === 'sys' && config.relFormId === 'user') {
    // TODO
  } else if (config.selectTable && config.selectTable === 'customization' && config.isSource && config.isSource === 2) {
    if (JSON.stringify(userType) === '{}') getUserType()
    list = await getUserList()
  } else if ((!config.selectTable || config.selectTable === 'customization') && (!config.isSource || config.isSource === 1)) {
    const res = await apiGetreportdatalist(par)
    if (res.code === 0) {
      list = res.data
    }
  }
  return list
}

const getOrganizationType = async function () {
  // 获取组织类型
  if (skey.value && !localStorage.getItem('user')) return
  const { data, code, msg } = await getdepttiplist({ curpage: 1, pagesize: 9999 })
  if (code === 0) {
    organizationType.value = data
  } else {
    ElMessage.error(msg)
  }
}

const getUserType = async function () {
  // 获取用户类型
  if (skey.value && !localStorage.getItem('user')) return
  const { code, data } = await getnoopenusertiplist({ curpage: 1, pagesize: 999999 }).catch(err => { console.log(err) })
  if (code === 0) {
    const type = {}
    for (const i of data) {
      type[i.keytype] = i.name
    }
    userType.value = type
  }
}

const getOrgList = async function (param) {
  // 获取组织数据
  const obj = { pid: -1, curpage: 0, pagesize: 0, ...param }
  // 从空间进入，需要传空间id
  if (spaceid) {
    obj.spaceid = spaceid;
  } else if (upaceid) {
    obj.upaceid = upaceid
  }
  const { code, data } = await getapiorganizationlist(obj).catch(e => { console.log(e) })
  if (code === 0) {
    return data
  }
}

const getUserList = async function () {
  if (skey.value && !localStorage.getItem('user')) return []
  // 获取用户数据
  const { code, data } = await getapiuserlist({ curpage: 0, pagesize: 0 }).catch(e => { console.log(e) })
  if (code === 0) {
    // 值类型转化
    let ars = setUserTitle(data)
    return ars
  }
}

const setUserTitle = function (data) {
  return data.map(its => {
    its.idcardtype = !its.idcardtype ? '其他' : jsonType.identityTypes[its.idcardtype - 1].label
    its.sex = !its.sex && its.sex !== 0 ? '' : jsonType.gender[its.sex].label
    return its
  })
}

const getLinkUserList = async function () {
  if (skey.value && !localStorage.getItem('user')) return []
  let list = []
  const data = getControlConfig.value
  let isLinked = false
  if (data.dataconfig && data.dataconfig.setUpValue == 3 && data.dataconfig.linked && data.dataconfig.linked.conditional) {
    const param = linkedSetEvent(data.dataconfig, props.addConfig.formdata, { index: data.indexs });
    if (param) {
      param.approvingId = props.applyInfo.id
      const link = await getlinkeddatalist(param)
      isLinked = true
      if (link.code == 0) {
        list = link.data[0]
      }
    }
  } else {
    const obj = { curpage: userCurpage.value, pagesize: 50 }
    // if (data.lookCustomArr) {
    //   const id = (typeof data.lookCustomArr === 'string' ? JSON.parse(data.lookCustomArr) : data.lookCustomArr || []).map(c=> c.organizationId).join(',')
    //   if (data.lookCustomChild) {
    //     obj.organizationIdss = id
    //   } else {
    //     obj.organizationsId = id
    //   }
    // }
    if (data.lookRMSIsUser === 1 || data.lookRMSIsUser === 2) {
      obj.orgtype = data.lookRMSIsUser
    } else if (data.lookRMSIsUser === 4) {
      const list = typeof data.lookCustomArr === 'string' ? JSON.parse(data.lookCustomArr) : data.lookCustomArr
      if (list.length > 0) {
        let organizationsId = list.map(item => item.organizationId)
        // 联系人控件-部门查看范围-自定义（是否选择子部门）
        if (!data.lookCustomChild) {
          obj.organizationIdss = organizationsId.join(',');
        } else {
          obj.organizationsId = organizationsId.join(',');
        }
      }
    }
    if (data.lookRMSIsUserRole === 1) {
      obj.roletype = 1
    } else if (data.lookRMSIsUserRole === 3) {
      const list = typeof data.lookCustomArrRole === 'string' ? JSON.parse(data.lookCustomArrRole) : data.lookCustomArrRole
      if (list.length > 0) {
        let roleId = list.map(item => item.roleId)
        obj.rolesId = roleId.join(',');
      }
    }
    const res = await getopenuserlist(obj)
    if (res.code === 0) {
      list = res.data.map(c => {
        return {
          realname: c.realname,
          userId: c.userId
        }
      })
    }
  }
  return { list, isLinked }
}

const getBindFiledData = async function (val) {
  if (skey.value && !localStorage.getItem('user')) return []
  if (val && val[0] === '$') {
    let res = getFilterValue(val, cloneDeep(customDataList.value))
    return Array.isArray(res) ? res[0] : res
  }
  const { code, data } = await getapprovalbindval({ feild: val }).catch(err => { console.log(err) })
  if (code === 0) {
    return data
  }
}

const getDictionaryData = async function () {
  if (skey.value && !localStorage.getItem('user')) return []
  const dicList = info.dictionary || []
  const result = []
  for (const dic of dicList) {
    const { code, data } = await openapiGetoptions({ optionsId: dic.optionsId }).catch(err => { console.log(err) })
    if (code === 0) {
      if (data.options) {
        const li = JSON.parse(data.options)
        result.push(...li)
      }
    }
  }
  return result
}

const goSelUser = async function () {
  const data = getControlConfig.value
  isAppenUserPop.value = true
  const selectRef = userSelectRef.value
  if (selectRef && userPopWidth.value === 300) {
    userPopWidth.value = selectRef.getBoundingClientRect().width
  }
  const ref = linkedDropDownRef.value
  if (isDefaultFilterOpt.value) {
    if (ref && data.dataconfig && data.dataconfig.setUpValue == 3 && data.dataconfig.linked && data.dataconfig.linked.conditional) {
      // 联动
      const { list } = await getLinkUserList()
      ref.getList(data, list, { channel: 'link', parentDiv: selectRef }, '', userSelectText.value)
    } else {
      ref.getNewList(data, { channel: 'newList', parentDiv: selectRef }, '', userSelectText.value);
    }
  } else {
    let list = []
    if (tempUserList.value.length === 0) {
      list = await getUserDataOpt()
      tempUserList.value = Object.freeze(list)
    } else {
      list = tempUserList.value
    }
    ref.getList(data, list, { channel: 'link', parentDiv: selectRef }, '', userSelectText.value)
  }
}

const openUserOrg = function () {
  const data = getControlConfig.value
  const opt = {
    id: props.applyInfo.id,
    data,
    info: info.organize || []
  }
  const param = getUserParam(opt)
  if (data.type == 'roule' && data.lookRMSIsUserRole == 2) {
    delete param.onlyUser
    param.curHigh = spaceid ? 3 : 1
    multipleChoiceRef.value.multipleChoiceMethod(param);
  } else {
    multipleChoiceRef.value.multipleChoiceMethod(param);
  }
}

const openSearchUser = function () {
  const data = getControlConfig.value
  if (isMultiple.value) {
    data.singleIsUser = 1
  } else {
    data.singleIsUser = 0
  }
  batchSearchRef.value.fromParentMethod(data);
}

const fromMultipleChoice = function (e) {
  const arr = e.checkedArrUser.map(m => ({ realname: m.realname, userId: m.userId }))
  console.log(arr,'adsdadadadsadsd', isMultiple.value)
  if (isMultiple.value) {
    info.organize = arr
  } else {
    if (arr[0]) {
      info.organize = [arr[0]]
    }
  }
  dealCondition(conditionValue.value)
}

const handleBatchSearchChild = function (param) {
  const obj = {
    checkedArrUser: param.user
  }
  fromMultipleChoice(obj)
}

const handelChange = function () {
  if (isOld.value) emit('change', info)
}

const checkChange = function (val) {
  const isBool = typeof val === 'boolean'
  if (isBool) {
    let list = []
    if (val) {
      info.value = ['全部']
      list = defalutOption.value
    } else {
      info.value = []
      list = ['_全部_']
    }
    dealDefaultDate(list)
  } else {
    if (isMultiple.value) {
      // 多选
      info.value = val.filter(c => c !== '全部')
      info.checkAll = false
      dealDefaultDate(info.value)
    } else {
      // 单选的情况
      const res = cloneDeep(val).filter(c => c !== '全部')
      const last = res[res.length - 1]
      if (last === undefined) {
        info.value = []
      } else {
        info.value = [last]
      }
      info.checkAll = false
      if (!isMultiple.value) {
        isAppenPop.value = false
      }
      dealDefaultDate(info.value)
    }
  }
}

const checkUserChange = function (val) {
  // 联系人控件单独修改
  isItManual.value = true
  const isBool = typeof val === 'boolean'
  if (isBool) {
    if (val) {
      info.value = ['全部']
      userList.value = ['全部']
      info.organize = optSearchList.value.map(c => ({ realname: c.value, userId: c.userId }))
    } else {
      info.value = []
      userList.value = []
      info.organize = []
    }
  } else {
    info.value = val.filter(c => c !== '全部')
    userList.value = val.filter(c => c !== '全部')
    info.checkAll = false
    const list = []
    for (const ele of val) {
      const item = optSearchList.value.find(c => c.userId === ele)
      if (item) {
        list.push(item)
      }
    }
    info.organize = list.map(c => ({ realname: c.value, userId: c.userId }))
    info.value = list
  }
  dealCondition(conditionValue.value)
}

const dealCondition = function (e, isInit, isDateChange) {
  let { screenType, title, value, organize, isSearch = true, organizationList = [], roleList = [] } = cloneDeep(info)
  if ((isUser.value || isOrganization.value || isRole.value) && e === undefined) {
    e = 'in'
  }
  let condition = looperOption.value.find(item => item.val === e)
  if (isDate.value && !isDateChange) {
    if (e !== 'between') {
      let val
      if (e && e[0] === '$') {
        val = getFilterValue(e, cloneDeep(customDataList.value))
        if (val && val[0]) {
          // 时间就要这样的格式
          val = [new Date(val[0] + ' 00:00:00').getTime(), new Date(val[0] + ' 23:59:59').getTime()]
        }
        condition = { name: '介于', val: 'between', isCustom: true }
        value = val
      } else {
        val = getConditionTime({ conditionName: condition.name })
      }
      const date = val.map(c => dayjs(c).format('YYYY-MM-DD'))
      console.log(date,'datedatedate')
      info.value = date
    }
  }
  value = info.value
  if (isDateChange && isDate.value) {
    conditionValue.value = 'between'
    condition = looperOption.value.find(item => item.val === conditionValue.value)
  }
  let obj = {
    condition,
    type: screenType,
    title,
    value: value ? value.filter(c => c !== '全部') : [''],
    isSearch,
    isData: isData.value,
    id: info.i,
  }
  if (obj.value.length !== 0) {
    obj.isData = true
  }
  if (isUser.value && isUserSel.value) {
    obj.value = organize
  } else if (isOrganization.value) {
    obj.value = formatOrg(organizationList)
  } else if (isRole.value) {
    obj.value = formatRole(roleList)
  }
  if (isDate.value && obj.value.length > 0) {
    // 处理一下日期的开始时间和结束时间
    const dateArr = cloneDeep(obj.value)
    if (info.sourceList && info.sourceList.length > 0) {
      obj = getChildScreen(obj, dateArr)
    }
    if (info.dateValue) {
      const val = dateArr[info.dateValue - 1]
      obj.value = [val, val]
    }
  }
  if (props.isInDetailed) {
    const list = getInDetailedObj(obj)
    obj = {
      id: info.i,
      list
    }
  }
  if (props.dataInfo.parent) {
    // 说明是明细表里的字段
    obj.parent = props.dataInfo.parent
  }
  screenResValue.value = obj.value
  if (screenItemList.value.length !== 0 && Object.keys(screenItemInit.value).length !== screenItemList.value.length) return false
  emit('change-new-screen', obj, info)
  if (isInit !== true) {
    if (value && Array.isArray(value) && value[0] === '') {
      emit('change-screen-id', -1)
    } else {
      emit('change-screen-id', info.i)
    }
  }
  isData.value = true
}

const removeTag = function (e) {
  if (isOrganize.value || isRole.value) {
    if (isOrganize.value) {
      // eslint-disable-next-line vue/no-mutating-props
      info.organizationList = info.organizationList.filter(c => getOrgShowName(c) !== e)
      info.value = cloneDeep(info.organizationList)
    } else {
      // eslint-disable-next-line vue/no-mutating-props
      info.roleList = info.roleList.filter(c => c.name !== e)
      info.value = cloneDeep(info.roleList)
    }
    dealCondition(conditionValue.value)
  } else {
    if (e === '全部') {
      info.checkAll = false
      // 欧总说 全部取消  直接显示空的
      dealDefaultDate(['_全部_'])
    } else {
      let idx = -1
      const val = info.value[0]
      if (val && typeof val === 'object' && val !== null) {
        idx = info.value.findIndex(c => c.value === e)
      } else {
        idx = info.value.findIndex(c => c === e)
      }
      if (idx !== -1) {
        // eslint-disable-next-line vue/no-mutating-props
        info.value.splice(idx, 1)
      }
      dealDefaultDate(info.value)
    }
  }
}

const removeUserTag = function (e) {
  // eslint-disable-next-line vue/no-mutating-props
  info.organize = info.organize.filter(c => c.userId !== e)
  dealCondition(conditionValue.value)
}

const closeFlow = function (index) {
  // eslint-disable-next-line vue/no-mutating-props
  info.organize.splice(index, 1)
  dealCondition(conditionValue.value)
}

const dealDefaultDate = function (value, isInit = false) {
  const { screenType, title, isSearch = true, isAppenAll = true, screenLevel, customOptionType, activeName, customOption } = cloneDeep(info)
  // 处理一下自定义选项的真实值和显示值
  let isNull = false
  if (activeName === 'custom') {
    if (customOptionType === 'option') {
      value = value.map(item => {
        const iten = customOption.find(iten => { return item === iten.label })
        return iten ? iten.value : item
      })
    } else if (customOptionType === 'check') {
      const optionIndex = customOption.findIndex(iten => { return value[0] === iten.value })
      if (optionIndex === 1) {
        // 取消选择的
        const option = customOption[optionIndex]
        // 如果存在逗号就要过滤空值
        if (option.value.search(',') !== -1) {
          isNull = true
        }
      }
    }
  }
  if (isCustomCheck.value) {
    const arr = []
    value.forEach(item => {
      arr.push(...item.split(','))
    })
    value = [...new Set(arr)]
  }
  let obj = {
    type: screenType,
    title,
    isSearch,
    isData: isData.value,
    id: info.i,
    isAppenAll,
    isNull
  }
  if (isTextSearch.value) {
    obj.value = [searchValue.value]
    obj.values = searchValue.value
  } else {
    obj.value = value
    obj.values = value
  }
  if (obj.value.length !== 0) {
    obj.isData = true
  }
  if (info.isAppenAll && ((info.value[0] === '全部' && value[0] === '') || (info.value.length === 0 && value.length === 0))) {
    if (screenLevel && screenLevel.levelList.length > 0) {
      // 选择了全部且单级就不用赋值了
      if (screenLevel.levelType === 'single') {
        // obj.value = defalutOption.value
        // obj.values = defalutOption.value
      }
      // 选择了全部且多级在多级树中触发
    }
  } else if (screenLevel && screenLevel.levelType === 'multiple') {
    // 如果是多级多选且不是全部的话这边
    isData.value = false
    emit('close-loading', info.i)
    return
  }
  if (info.sourceList && info.sourceList.length > 0) {
    obj = getChildScreen(cloneDeep(obj))
  }
  if (obj.value.length > 0 && info.firstScreenField) {
    obj = getRealScreenValue(obj)
  }
  if (props.isInDetailed) {
    const list = getInDetailedObj(obj)
    obj = {
      id: info.i,
      list
    }
  }
  if (props.isSotpInitTable && obj.value.length === 0) {
    obj.isData = false
  }
  screenResValue.value = obj.value
  if (screenItemList.value.length !== 0 && Object.keys(screenItemInit.value).length !== screenItemList.value.length) return false
  // 如果有过滤字段切选项是空的 那就传个不存在的值去做过滤
  if (defalutOption.value.length === 0 && info.title && !isTextSearch.value) {
    obj.value = ['_不过滤数据_']
    obj.values = ['_不过滤数据_']
  }
  if (props.dataInfo.parent) {
    // 说明是明细表里的字段
    obj.parent = props.dataInfo.parent
  }
  emit('change-new-screen', obj, info)
  isData.value = true
  if (isInit !== true) {
    if (value && Array.isArray(value) && value[0] === '') {
      emit('change-screen-id', -1)
    } else {
      emit('change-screen-id', info.i)
    }
  }
}

const multipleLevelDealDefaultDate = function (filterValue, lableValue, isInit = false) {
  filterValueObj.value = filterValue ? cloneDeep(filterValue) : {}
  lableValueObj.value = lableValue ? cloneDeep(lableValue) : {}
  const { screenType, title, value, organize, isSearch = true } = cloneDeep(info)
  let obj = {
    filterValueObj: filterValue || {},
    isData: true,
    isScreenTree: true,
    title,
    type: screenType,
    value: [''],
    values: '',
    id: info.i
  }
  if (info.isSearch === false) {
    obj.filterValueObj = {}
    obj.isData = false
  }
  screenResValue.value = obj.value
  if (props.dataInfo.parent) {
    // 说明是明细表里的字段
    obj.parent = props.dataInfo.parent
  }
  if (isInit && isInit.value === false) {
    // 是否初始化数据
    emit('close-loading', info.i)
    emit('change-new-screen', obj, info)
    isData.value = false
  } else {
    if (props.isInDetailed) {
      const list = getInDetailedObj(obj)
      obj = {
        id: info.i,
        list
      }
    }
    emit('change-new-screen', obj, info)
  }
}

// 获取明细表需要的格式
const getInDetailedObj = (obj) => {
  const list = []
  if (info.screenLevel.levelType === 'multiple') {
    if (obj.filterValueObj && Object.keys(obj.filterValueObj).length > 0) {
      for (const key in obj.filterValueObj) {
        const value = obj.filterValueObj[key]
        const [title, type, id, customName] = key.split('_')
        const obs = {
          filterId: id,
          title: title,
          value: value,
          relation: 'in',
        }
        if (customName) {
          obs.isCustom = true
          obs.customName = customName
        }
        list.push(obs)
      }
    }
  } else {
    const o = {
      filterId: obj.id,
      title: '' + info.checkName + obj.id,
      value: obj.value,
      relation: 'in'
    }
    if (isNum.value && conditionValue.value) {
      o.relation = conditionValue.value
    }
    if (info.isSearch === false) {
      o.isSearch = false
    }
    if (info.isCustom) {
      o.isCustom = true
      o.customName = info.customName
    }
    list.push(o)
    if (obj.childScreen && Object.keys(obj.childScreen).length > 0) {
      for (const key in obj.childScreen) {
        const value = obj.childScreen[key]
        const [title, type, id, customName] = key.split('_')
        const obs = {
          filterId: id,
          title: title,
          value: value,
          relation: 'in',
        }
        if (customName) {
          obs.isCustom = true
          obs.customName = customName
        }
        list.push(obs)
      }
    }
  }

  return list
}
// 获取主筛选真正的筛选值
const getRealScreenValue = (obj) => {
  try {
    let title = info.firstScreenField
    const { dataInfo } = info.screenLevel.levelList[0]
    if (dataInfo.datatype === 4 || dataInfo.datatype === 2) {
      // 数据源是工坊 要用名称取匹配
      const shopField = dataInfo.allData.find(item => { return item.title === title })
      if (shopField) {
        title = shopField.name
      }
    }
    const field = info.screenLevel.levelList[0].field
    let valueList = []
    const masterValue = obj.value[0] === '全部' ? defalutOption.value : obj.value
    if (field && title !== field.split('_')[0]) {
      // 显示字段和筛选字段不一样再去获取别的数据值
      masterValue.forEach(val => {
        let key = val
        if (typeof val === 'object') {
          key = `${val.realname || val.name}_${val.userId || val.organizationId || val.roleId}`
        }
        // 存在值
        if (optionMoreData.value[key] && optionMoreData.value[key][title] !== undefined) {
          let value = optionMoreData.value[key][title]
          if (Array.isArray(value)) {
            valueList.push(...value)
          } else {
            valueList.push(value)
          }
        } else {
          valueList.push(val)
        }
      })
      obj.value = Array.from(new Set(valueList))
      obj.values = Array.from(new Set(valueList))
    } else {
      obj.value = Array.from(new Set(masterValue))
      obj.values = Array.from(new Set(masterValue))
    }

    return obj
  } catch (error) {
    return obj
  }
}
// 获取一下子筛选的数据
const getChildScreen = (obj, dateArr) => {
  if (info.screenLevel && info.screenLevel.levelList) {
    const { isMoreFiled, moreFiledList, dataInfo } = info.screenLevel.levelList[0]
    if (isMoreFiled || isData.value) {
      if (!obj.childScreen) {
        obj.childScreen = {}
      }
      info.sourceList.forEach(item => {
        // 获取需要过滤的字段
        let data
        if (item.isCustom) {
          data = info.variableConfig.find(iten => { return iten.title === item.sourceField })
        } else {
          data = info.datas.find(iten => { return iten.title === item.sourceField })
        }
        if (data) {
          let sourceKey = props.isInDetailed ? `${data.title}_${data.type}_${item.id}` : `${data.title}_${data.type}`
          let screenKey = item.screenField
          // 如果数据源是工坊就用名字去匹配数据
          if (dataInfo.datatype !== 1) {
            const screenFieldData = moreFiledList.find(iten => { return iten.title === item.screenField })
            screenKey = screenFieldData.name
          }
          if (item.isCustom) sourceKey += `_${data.name}`
          obj.childScreen[sourceKey] = []
          if (dateArr) {
            // 日期筛选分开传值
            obj.childScreen[sourceKey] = item.dateValue ? [dateArr[item.dateValue - 1], dateArr[item.dateValue - 1]] : dateArr
          } else {
            // 通过主筛选的数据获取子筛选的过滤值
            obj.value.forEach(masterValue => {
              let key = masterValue
              if (typeof masterValue === 'object') {
                key = `${masterValue.realname || masterValue.name}_${masterValue.userId || masterValue.organizationId || masterValue.roleId}`
              }
              if (optionMoreData.value[key] && optionMoreData.value[key][screenKey] !== undefined) {
                let value = optionMoreData.value[key][screenKey]
                value = Array.isArray(value) ? value : [value]
                obj.childScreen[sourceKey].push(...value)
              }
            })
          }

        }
      })
    }
  }
  return obj
}


// Watch
watch(props.dataInfo, function (val) {
  if (val) {
    info = reactive(cloneDeep(val))
  }
}, { deep: true, immediate: true })


watch(()=> isAppenPop.value, function (val) {
  if (val) {
    let width = null
    if (orgSelectRef.value) {
      width = orgSelectRef.value.getBoundingClientRect().width
    } else if (defaultShowRef.value) {
      width = defaultShowRef.value.$el.getBoundingClientRect().width
    }
    popWidth.value = width
  }
})

watch(() => info.value, function (val) {
  if (isOld.value) return
  if (Array.isArray(val)) {
    let li = []
    for (const item of val) {
      if (isObject(item)) {
        const text = item.value
        li.push(text)
      } else {
        li.push(item)
      }
    }
    li = Array.from(new Set(li)).filter(c => c)
    inputAppenText.value = li
  }
}, { deep: true, immediate: true })

watch(props.totalParams, function () {
  if (isUser.value && !isDefaultFilterOpt.value) {
    getUserDataOpt(false)
  } else if (!isDefaultFilterOpt.value && isSelect.value) {
    if (isParentExpand.value) {
      isParentExpand.value = false
    } else {
      showList(false)
    }
  }
}, { deep: true })

if (info.screenLevel && info.screenLevel.levelList) {
  watch(info.screenLevel.levelList, function (newVal, oldVal) {
    if (oldVal === undefined && newVal && newVal.length > 0) {
      // 第一次进入
      setScreenLevel()
    }
  }, { deep: true, immediate: true })
}


// Created
info.FilterCustomize = []
setTimeout(() => {
  if (isOld.value) {
    info.value = info.FilterValue
    emit('change-value')
  } else init()
  getOptionConfig()
}, 500);


defineExpose({
  info,
  isData,
  init,
  expandSelect,
  optionMoreData,
  optSearchList,
  lableValueObj
})
</script>
<style lang='scss' scoped>
::v-deep .el-select {
  height: 30px;

  .el-select__wrapper {
    height: 30px;
    min-height: 30px; // 修改组件默认大小
  }
}

.num-select {
  min-width: 80px !important;
}

.org-and-role-search-single {
  &-item {
    height: 30px;
    line-height: 30px;
    padding: 0 12px;
    box-sizing: border-box;
    font-weight: 400;
    position: relative;
    cursor: pointer;
    color: #333;
    white-space: nowrap;
    border-radius: 4px;
  }
}


.detail {
  --el-component-size-small: 30px; // 修改组件默认大小
  --el-date-editor-daterange-width: initial; // 修改组件默认大小
  --theme-color: #4e86ff;
  $themeColor: var(--theme-color);
  $opacityTheme: var(--opacity-theme);
  height: 100%;
  box-sizing: border-box;

  .h-fit {
    min-height: 40px;
  }

  ::v-deep .el-date-editor.el-input__wrapper {
    width: initial !important;
    flex: 1;
  }

  .between-select {
    width: 80px !important;
    flex: none;
  }

  .relationUserStyle {
    line-height: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $themeColor;
    display: inline-block;
    color: white;
    border-radius: 4px;
    font-size: 12px;
    padding: 0 10px;
    margin: 0 0 0 5px;
  }

  ::v-deep .el-tag--info {
    border-color: $themeColor;
    background: $themeColor;
    color: #fff;

    .el-tag__close {
      color: #fff;
      background-color: $themeColor;
    }
  }

  ::v-deep .drop-down-box {
    height: 30px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    position: relative;
    overflow: hidden;
    border-color: #DCDFE6;
    width: 100%;

    .el-tag {
      height: 24px;
      line-height: 24px;
    }

    .drop-down-box-input {
      width: 100%;
    }

    .icon-sousuo {
      position: relative;
      color: #DCDFE6;
    }
  }

  .verticalL {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    overflow: hidden;
    flex: 1;
    position: relative;

    &-item {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      transition: .3s;
      width: 100%;
    }

    .change-tab {
      width: 30px;
      height: 100%;
      position: absolute;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      &-item {
        width: 14px;
        margin-right: 2px;
        display: flex;
        align-items: center;
        color: $themeColor;
        cursor: pointer;
        height: 100%;

        .is-disabled {
          color: #D8D8D8 !important;
        }

        .iconfont {
          font-size: 12px;
        }

        .icon-xia {
          display: inline-block;
          transform: rotate(90deg);
        }

        &:last-of-type {
          margin-right: 0;
        }

        &:hover {
          background-color: $opacityTheme;
        }
      }

      .disabled {
        color: #D8D8D8;
      }
    }

    .el-checkbox {
      height: 30px;
      line-height: 30px;
    }

    ::v-deep .el-scrollbar {
      .el-scrollbar__wrap {
        overflow-x: auto !important;

        .el-scrollbar__view {
          display: flex;
        }
      }
    }

    .single-item {
      height: 30px;
      line-height: 30px;
      margin: 0 12px;
      font-weight: 400;
      font-size: 16px;
      position: relative;
      cursor: pointer;
      color: #333;
      white-space: nowrap;

      &:first-of-type {
        margin-left: 0;
      }
    }

    .single-item-active {
      color: $themeColor !important;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: $themeColor;
      }
    }
  }

  &-screen {
    box-sizing: border-box;

    &-default {
      display: flex;
      flex: 1;
      position: relative;
      &-select {
        min-width: initial !important;
        flex: 1;
      }
      
      .num-select {
        min-width: 80px !important;
      }

      &-date {
        flex: 1;
        width: initial;
      }

      &-orgselect {
        display: flex;
        flex: 1;

        &-pop {
          height: 100%;
        }
      }

      .user-select {
        display: flex;
        flex: 1;

        &-pop {
          display: flex;
          align-items: center;
          border: 1px solid #DCDFE6;
          box-sizing: border-box;
          overflow: hidden;
          border-radius: 4px;
          height: 100%;

          ::v-deep .el-input {
            flex: 1;

            .el-input__wrapper {
              box-shadow: none;
            }
          }

          ::v-deep .el-tag {
            height: 24px;
            line-height: 24px;
            margin-left: 5px;
          }
        }

        .dividingLine {
          width: 1px;
          height: 14px;
          background-color: #D8D8D8;
        }

        &-icon {
          margin-left: 10px;
          width: 28px;
          height: 28px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          &:last-of-type {
            margin-left: 0;
          }

          .iconfont {
            color: $themeColor;
            font-size: 16px;
          }
        }
      }
    }
  }

  ::v-deep &-tranL {
    height: 100%;
    overflow: hidden;

    &-name {
      height: 40px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      cursor: pointer;

      .icon-wenjianjia1 {
        margin: 0 5px;
      }

      .name {
        flex: 1;
        color: #666666;
        font-size: 14px;
      }

      .iconfont {
        font-size: 14px;
      }

      .xiangyou {
        transform: rotate(-90deg);
      }

      .icon-xiangxia {
        color: #DCDFE6;
        display: inline-block;
        transition: .3s;
      }
    }

    .single-item {
      // height: 40px;
      // line-height: 40px;
      display: flex;
      align-items: center;
      min-height: 28px;
      font-weight: 400;
      font-size: 16px;
      font-family: PingFangSC;
      cursor: pointer;
      position: relative;
      padding-left: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .single-item-active {
      color: $themeColor;
      background-color: #4e86ff;

      &::after {
        content: '';
        background-color: $themeColor;
        position: absolute;
        height: 100%;
        width: 2px;
        left: 0;
        top: 0;
      }
    }

    &-opt {
      margin-left: 28px;
      transition: .3s;
      overflow: hidden;

      .el-checkbox {
        .el-checkbox__label {
          padding-left: 5px;
        }
      }

      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: $themeColor;
        border-color: $themeColor;
      }

      .is-checked {
        .el-checkbox__label {
          color: $themeColor;
        }

        .el-checkbox__input {
          .el-checkbox__inner {
            background-color: $themeColor;
            border-color: $themeColor;
          }
        }
      }
    }
  }

  ::v-deep .el-select {

    // min-width: 180px; 
    .el-select__tags {
      flex-wrap: nowrap;
    }

    .el-input__suffix {

      .el-select__caret,
      .el-icon-search {
        line-height: 30px;
      }
    }
  }

  ::v-deep .el-input__inner {
    height: 28px;
    line-height: 28px;
    font-size: 12px;
  }

  ::v-deep .el-range-input {
    font-size: 12px;
  }

  .flex {
    display: flex;
    align-items: center;
    height: 100%;

    .label {
      margin-right: 10px;
      font-size: 14px;
      font-weight: 600;
      white-space: nowrap;
      color: #666666;
    }
  }

  .screen {
    float: left;
    margin-right: 20px;
    width: 80px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    text-align: center;
    color: #fff;
    background: $themeColor;
    border-radius: 3px;
  }
}

::v-deep .el-input {
  .el-input__prefix {
    .el-icon-search {
      line-height: 30px;
    }
  }
}

::v-deep .tranL-content {
  height: 100%;

  .el-scrollbar__view {
    display: flex;
    flex-direction: column;
  }

  .el-input {
    width: initial;

    .el-input__prefix {
      .el-icon-search {
        line-height: 30px;
      }
    }
  }
}

::v-deep .el-checkbox {
  margin-right: 0;
  display: flex;
  align-items: center;

  .el-checkbox__label {
    flex: 1;
  }
}

.verticalL-item-checkbox {
  margin-right: 15px !important;
  &:last-of-type {
    margin-right: 0 !important;
  }
}

.screen-popp-content {
  height: 240px;
}

::v-deep .select-hidden-options {
  .el-select__wrapper.is-disabled {
    cursor: pointer !important;
    background-color: initial;
    .el-tag {
      cursor: pointer !important;
    }
  }
  .el-select-dropdown {
    display: none !important;
  }
}
</style>

<style lang="scss">
.screen-popp {

  // padding-right: 0 !important;
  .el-input {
    margin-bottom: 10px;

    // width: 168px;
    .el-input__inner {
      height: 30px;
      line-height: 30px;
    }

    .el-input__icon {
      line-height: 30px;
    }
  }
}

.user-pop {
  padding: 0 !important;
  border: none;
  overflow: visible;
  margin-top: -30px;
}

.single-tree-head {
  padding: 0 10px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  ::v-deep .el-input {
    width: 90%;
  }

  .icon-shuaxin {
    cursor: pointer;
    color: #4E86FF;
    margin-left: 8px;
    line-height: 32px;
    font-size: 24px;
  }
}
</style>
